import { defineMessages } from 'react-intl';

export default defineMessages({
    noAnswers: {
        id: "medicalRecords.noAnswers",
        defaultMessage: "Não há respostas"
    },
    actions: {
        id: 'medicalRecords.actions',
        defaultMessage: 'Ações'
    },
    actionsSave: {
        id: 'actions.save',
        defaultMessage: 'Salvar',
    },
    uploadFormTitle: {
        id: "uploadForm.title",
        defaultMessage: "Upload e Processamento",
    },
    uploadFormUploadSection: {
        id: "uploadForm.uploadSection",
        defaultMessage: "Upload de Documentos",
    },
    uploadFormPipelineSection: {
        id: "uploadForm.pipelineSection",
        defaultMessage: "Pipeline do Agente",
    },
    actionsSaveAndRelease: {
        id: 'actions.saveAndRelease',
        defaultMessage: 'Salvar e Liberar',
    },
    actionsSaving: {
        id: 'actions.saving',
        defaultMessage: 'Salvando...',
    },
    notConfigured: {
        id: 'graphic.notConfigured',
        defaultMessage: 'Não é possível exibir o gráfico. O campo não está configurado.',
    },
    downloadImage: {
        id: 'graphic.downloadImage',
        defaultMessage: 'Baixar imagem',
    },
    '7days': {
        id: 'graphic.ranges.7days',
        defaultMessage: '7 dias atrás',
    },
    '15days': {
        id: 'graphic.ranges.15days',
        defaultMessage: '15 dias atrás',
    },
    '30days': {
        id: 'graphic.ranges.30days',
        defaultMessage: '30 dias atrás',
    },
    allPeriod: {
        id: 'graphic.ranges.allPeriod',
        defaultMessage: 'Todo período',
    },
    columns: {
        id: 'graphic.series.columns',
        defaultMessage: 'Colunas',
    },
    attentionBlocked: {
        id: 'graphic.series.attentionBlocked',
        defaultMessage: 'Atent. {date}',
    },
    attentionCurrent: {
        id: 'graphic.series.attentionCurrent',
        defaultMessage: 'Atent. {date}',
    },
    attentionHistory: {
        id: 'graphic.series.attentionHistory',
        defaultMessage: 'Atent. {date}',
    },
    dateFormat: {
        id: 'graphic.dateFormat',
        defaultMessage: 'DD/MM/YYYY',
    },
    history: {
        id: 'medicalRecords.history',
        defaultMessage: 'Histórico'
    },
    points: {
        id: 'medicalRecords.points',
        defaultMessage: 'Pontos: {points}'
    },
    resultQualifier: {
        id: 'medicalRecords.resultQualifier',
        defaultMessage: 'Qualificador do resultado'
    },
    deficiencyQualifier: {
        id: 'medicalRecords.deficiencyQualifier',
        defaultMessage: 'Qualificador da deficiência'
    },
    searchCid: {
        id: 'searchCid',
        defaultMessage: 'Pesquisar CID',
    },
    cid11: {
        id: 'cid11',
        defaultMessage: 'CID 11',
    },
    showHour: {
        id: 'showHour',
        defaultMessage: 'Exibir Horário',
    },
    hideHour: {
        id: 'hideHour',
        defaultMessage: 'Esconder Horário',
    },
    searchExams: {
        id: 'medicalRecords.searchExams',
        defaultMessage: 'Buscar Exames'
    },
    search: {
        id: 'medicalRecords.search',
        defaultMessage: 'Pesquisar'
    },
    searchByTitle: {
        id: 'medicalRecords.searchByTitle',
        defaultMessage: 'Pesquisar por título'
    },
    add: {
        id: 'medicalRecords.add',
        defaultMessage: 'Adicionar'
    },
    generalHistory: {
        id: 'medicalRecords.generalHistory',
        defaultMessage: 'Histórico Geral'
    },
    examHistory: {
        id: 'medicalRecords.examHistory',
        defaultMessage: 'Histórico de Exames'
    },
    deleteExam: {
        id: 'deleteExam',
        defaultMessage: 'Deletar Exame',
    },
    remove: {
        id: 'medicalRecords.remove',
        defaultMessage: 'Remover'
    },
    table: {
        id: 'medicalRecords.table',
        defaultMessage: 'Tabela'
    },
    graphic: {
        id: 'medicalRecords.graphic',
        defaultMessage: 'Gráfico'
    },
    closeModal: {
        id: 'medicalRecords.closeModal',
        defaultMessage: 'Fechar Modal'
    },
    selectPlaceholder: {
        id: 'medicalRecords.selectPlaceholder',
        defaultMessage: 'Selecione'
    },
    deleteExercise: {
        id: 'medicalRecords.deleteExercise',
        defaultMessage: 'Deletar Exercício'
    },
    imageHistory: {
        id: 'medicalRecords.imageHistory',
        defaultMessage: 'Histórico das imagens'
    },
    selectImageCategory: {
        id: 'medicalRecords.selectImageCategory',
        defaultMessage: 'Selecione a categoria da imagem'
    },
    description: {
        id: 'medicalRecords.description',
        defaultMessage: 'Descrição'
    },
    uploadImage: {
        id: 'medicalRecords.uploadImage',
        defaultMessage: 'Fazer upload de imagem'
    },
    imageHistoryTitle: {
        id: 'medicalRecords.imageHistoryTitle',
        defaultMessage: 'Histórico de Imagens'
    },
    uploadSuccess: {
        id: 'medicalRecords.uploadSuccess',
        defaultMessage: 'Upload realizado com sucesso!'
    },
    uploadError: {
        id: 'medicalRecords.uploadError',
        defaultMessage: 'Erro ao fazer upload!'
    },
    imageTypeError: {
        id: 'medicalRecords.imageTypeError',
        defaultMessage: 'Você só pode fazer upload de arquivos JPG/PNG!'
    },
    imageSizeError: {
        id: 'medicalRecords.imageSizeError',
        defaultMessage: 'A imagem deve ter menos de {limit}MB!'
    },
    editText: {
        id: 'medicalRecords.editText',
        defaultMessage: 'Editar texto'
    },
    editTextTitle: {
        id: 'medicalRecords.editTextTitle',
        defaultMessage: 'Editar texto'
    },
    initialHour: {
        id: 'medicalRecords.initialHour',
        defaultMessage: 'Hora Inicial'
    },
    finalHour: {
        id: 'medicalRecords.finalHour',
        defaultMessage: 'Hora Final'
    },
    noInterval: {
        id: 'medicalRecords.noInterval',
        defaultMessage: 'sem intervalo'
    },
    hour: {
        id: 'medicalRecords.hour',
        defaultMessage: 'hora'
    },
    hours: {
        id: 'medicalRecords.hours',
        defaultMessage: 'horas'
    },
    minute: {
        id: 'medicalRecords.minute',
        defaultMessage: 'minuto'
    },
    minutes: {
        id: 'medicalRecords.minutes',
        defaultMessage: 'minutos'
    },
    second: {
        id: 'medicalRecords.second',
        defaultMessage: 'segundo'
    },
    seconds: {
        id: 'medicalRecords.seconds',
        defaultMessage: 'segundos'
    },
    deleteReport: {
        id: 'medicalRecords.deleteReport',
        defaultMessage: 'Deletar Relatório'
    },
    mathExpressionError: {
        id: 'medicalRecords.mathExpressionError',
        defaultMessage: 'Erro na Expressão Matemática'
    },
    mathExpressionErrorDescription: {
        id: 'medicalRecords.mathExpressionErrorDescription',
        defaultMessage: 'A expressão matemática criada para o campo {fieldName} apresenta um erro ou a possibilidade de mais de um resultado verdadeiro.'
    },
    mathExpressionErrorSolution: {
        id: 'medicalRecords.mathExpressionErrorSolution',
        defaultMessage: 'Por favor, revise a expressão matemática criada para este campo ou avise o administrador do sistema.'
    },
    calculationError: {
        id: 'medicalRecords.calculationError',
        defaultMessage: 'Erro ao calcular. Verifique a fórmula fornecida.'
    },
    waitingAnswerDescription: {
        id: 'medicalRecords.waitingAnswerDescription',
        defaultMessage: 'Este campo foi configurado para executar os cálculos apenas se todos os campos, que compõem a fórmula, estiverem preenchidos ou marcados.'
    },
    waitingAnswerConfig: {
        id: 'medicalRecords.waitingAnswerConfig',
        defaultMessage: 'Esta configuração pode ser revista e alterada na edição dos formulários ou dos campos.'
    },
    waitingAnswerHelp: {
        id: 'medicalRecords.waitingAnswerHelp',
        defaultMessage: 'Se achar necessário alterar, solicite a alteração ao administrador do sistema de sua clínica ou visite o nosso tutorial clicando neste {link}.'
    },
    attention: {
        id: 'medicalRecords.attention',
        defaultMessage: 'Atenção'
    },
    professionalName: {
        id: 'medicalRecords.professionalName',
        defaultMessage: 'Nome do Profissional'
    },
    name: {
        id: 'medicalRecords.name',
        defaultMessage: 'Nome'
    },
    author: {
        id: 'medicalRecords.author',
        defaultMessage: 'Autor'
    },
    visibility: {
        id: 'medicalRecords.visibility',
        defaultMessage: 'Visibilidade'
    },
    access: {
        id: 'medicalRecords.access',
        defaultMessage: 'Acesso'
    },
    version: {
        id: 'medicalRecords.version',
        defaultMessage: 'Versão'
    },
    cpf: {
        id: 'medicalRecords.cpf',
        defaultMessage: 'CPF'
    },
    gender: {
        id: 'medicalRecords.gender',
        defaultMessage: 'Sexo'
    },
    male: {
        id: 'medicalRecords.male',
        defaultMessage: 'Masculino'
    },
    female: {
        id: 'medicalRecords.female',
        defaultMessage: 'Feminino'
    },
    newProfessional: {
        id: 'medicalRecords.newProfessional',
        defaultMessage: 'Novo Profissional'
    },
    quickRegistration: {
        id: 'medicalRecords.quickRegistration',
        defaultMessage: 'Cadastro Rápido'
    },
    notApplicable: {
        id: 'medicalRecords.notApplicable',
        defaultMessage: 'N/A'
    },
    selectedValue: {
        id: 'medicalRecords.selectedValue',
        defaultMessage: 'Valor selecionado: {value}'
    },
    markNamePlaceholder: {
        id: 'medicalRecords.markNamePlaceholder',
        defaultMessage: 'Nome do Objetivo'
    },
    addMarkTitle: {
        id: 'medicalRecords.addMarkTitle',
        defaultMessage: 'Adicionar Objetivo'
    },
    newObjective: {
        id: 'medicalRecords.newObjective',
        defaultMessage: 'Novo Objetivo'
    },
    totalObjectives: {
        id: 'medicalRecords.totalObjectives',
        defaultMessage: 'Total de objetivos'
    },
    averageObjectives: {
        id: 'medicalRecords.averageObjectives',
        defaultMessage: 'Média dos objetivos'
    },
    progressPercentage: {
        id: 'medicalRecords.progressPercentage',
        defaultMessage: 'Progresso %'
    },
    progressObjectivesTooltip: {
        id: 'medicalRecords.progressObjectivesTooltip',
        defaultMessage: 'Progresso dos objetivos em andamento'
    },
    dashboard: {
        id: 'medicalRecords.dashboard',
        defaultMessage: 'Dashboard'
    },
    back: {
        id: 'medicalRecords.back',
        defaultMessage: 'Voltar'
    },
    next: {
        id: 'medicalRecords.next',
        defaultMessage: 'Próximo'
    },
    finish: {
        id: 'medicalRecords.finish',
        defaultMessage: 'Finalizar'
    },
    edit: {
        id: 'medicalRecords.edit',
        defaultMessage: 'Editar'
    },
    anterior: {
        id: 'medicalRecords.anterior',
        defaultMessage: 'Anterior'
    },
    posterior: {
        id: 'medicalRecords.posterior',
        defaultMessage: 'Posterior'
    },
    local: {
        id: 'medicalRecords.local',
        defaultMessage: 'Local'
    },
    view: {
        id: 'medicalRecords.view',
        defaultMessage: 'Visão'
    },
    type: {
        id: 'medicalRecords.type',
        defaultMessage: 'Tipo'
    },
    selectType: {
        id: 'medicalRecords.selectType',
        defaultMessage: 'Selecione o tipo'
    },
    assessment: {
        id: 'medicalRecords.assessment',
        defaultMessage: 'Avaliação'
    },
    reassessment: {
        id: 'medicalRecords.reassessment',
        defaultMessage: 'Reavaliação'
    },
    evolution: {
        id: 'medicalRecords.evolution',
        defaultMessage: 'Evolução'
    },
    medicalRelease: {
        id: 'medicalRecords.medicalRelease',
        defaultMessage: 'Alta'
    },
    death: {
        id: 'medicalRecords.death',
        defaultMessage: 'Óbito'
    },
    abandonment: {
        id: 'medicalRecords.abandonment',
        defaultMessage: 'Abandono de Tratamento'
    },
    renunciation: {
        id: 'medicalRecords.renunciation',
        defaultMessage: 'Desistência de Tratamento'
    },
    prom: {
        id: 'medicalRecords.prom',
        defaultMessage: 'PROM'
    },
    prem: {
        id: 'medicalRecords.prem',
        defaultMessage: 'PREM'
    },
    nps: {
        id: 'medicalRecords.nps',
        defaultMessage: 'NPS'
    },
    intensity: {
        id: 'medicalRecords.intensity',
        defaultMessage: 'Intensidade'
    },
    qualifier: {
        id: 'medicalRecords.qualifier',
        defaultMessage: 'Qualificador'
    },
    current: {
        id: 'medicalRecords.current',
        defaultMessage: 'Atual'
    },
    newArea: {
        id: 'medicalRecords.newArea',
        defaultMessage: 'Nova área'
    },
    lineWidth2px: {
        id: 'medicalRecords.lineWidth2px',
        defaultMessage: '2px'
    },
    lineWidth5px: {
        id: 'medicalRecords.lineWidth5px',
        defaultMessage: '5px'
    },
    lineWidth8px: {
        id: 'medicalRecords.lineWidth8px',
        defaultMessage: '8px'
    },
    lineWidth16px: {
        id: 'medicalRecords.lineWidth16px',
        defaultMessage: '16px'
    },
    mouthTongue: {
        id: 'medicalRecords.mouthTongue',
        defaultMessage: 'Boca Lingua'
    },
    mouth: {
        id: 'medicalRecords.mouth',
        defaultMessage: 'Boca'
    },
    upper: {
        id: 'medicalRecords.upper',
        defaultMessage: 'Superior'
    },
    views: {
        id: 'medicalRecords.views',
        defaultMessage: 'Visões'
    },
    selectSexToContinue: {
        id: 'medicalRecords.selectSexToContinue',
        defaultMessage: 'Selecione o sexo para continuar'
    },
    selectPainDescription: {
        id: 'medicalRecords.selectPainDescription',
        defaultMessage: 'Selecione o descritivo da dor'
    },
    mark: {
        id: 'medicalRecords.mark',
        defaultMessage: 'Marcar'
    },
    body: {
        id: 'medicalRecords.body',
        defaultMessage: 'Corpo'
    },
    head: {
        id: 'medicalRecords.head',
        defaultMessage: 'Cabeça'
    },
    selectAreaToContinue: {
        id: 'medicalRecords.selectAreaToContinue',
        defaultMessage: 'Selecione uma área para continuar'
    },
    or: {
        id: 'medicalRecords.or',
        defaultMessage: 'ou'
    },
    format: {
        id: 'medicalRecords.format',
        defaultMessage: 'Formato:'
    },
    format9x16: {
        id: 'medicalRecords.format9x16',
        defaultMessage: '9:16'
    },
    format1x1: {
        id: 'medicalRecords.format1x1',
        defaultMessage: '1:1'
    },
    format3x4: {
        id: 'medicalRecords.format3x4',
        defaultMessage: '3:4'
    },
    backgroundColor: {
        id: 'medicalRecords.backgroundColor',
        defaultMessage: 'Cor de fundo'
    },
    logo: {
        id: 'medicalRecords.logo',
        defaultMessage: 'Logo'
    },
    useWorkspaceLogo: {
        id: 'medicalRecords.useWorkspaceLogo',
        defaultMessage: 'Usar logo do workspace'
    },
    noLogoTooltip: {
        id: 'medicalRecords.noLogoTooltip',
        defaultMessage: 'Você não pode selecionar a logo do workspace, porque nenhuma imagem foi inserida. Por favor, faça o upload de uma imagem para defini-la como logo.'
    },
    subtitle: {
        id: 'medicalRecords.subtitle',
        defaultMessage: 'Subtítulo'
    },
    useWorkspaceName: {
        id: 'medicalRecords.useWorkspaceName',
        defaultMessage: 'Usar nome do workspace'
    },
    auditMessage: {
        id: 'medicalRecords.auditMessage',
        defaultMessage: 'O Resultado apresentado pode ser auditado no prontuário do profissional {speciality} {name} {council}, https://usecore.ai'
    },
    noDescriptionAdded: {
        id: 'medicalRecords.noDescriptionAdded',
        defaultMessage: 'Nenhum descrição adicionado.'
    },
    patient: {
        id: 'medicalRecords.patient',
        defaultMessage: 'Paciente'
    },
    newPatient: {
        id: 'medicalRecords.newPatient',
        defaultMessage: 'Novo Paciente'
    },
    objectivesProgress: {
        id: 'medicalRecords.objectivesProgress',
        defaultMessage: 'Progressão de Objetivos'
    },
    initialDate: {
        id: 'medicalRecords.initialDate',
        defaultMessage: 'Data Inicial'
    },
    finalDate: {
        id: 'medicalRecords.finalDate',
        defaultMessage: 'Data Final'
    },
    allSelectedPeriod: {
        id: 'medicalRecords.allSelectedPeriod',
        defaultMessage: 'Todo o período selecionado'
    },
    clearFilters: {
        id: 'medicalRecords.clearFilters',
        defaultMessage: 'Limpar Filtros'
    },
    apply: {
        id: 'medicalRecords.apply',
        defaultMessage: 'Aplicar'
    },
    objectivesDashboard: {
        id: 'medicalRecords.objectivesDashboard',
        defaultMessage: 'Dashboard dos Objetivos'
    },
    modal: {
        id: 'medicalRecords.modal',
        defaultMessage: 'Modal'
    },
    inProgress: {
        id: 'medicalRecords.inProgress',
        defaultMessage: 'Em Progresso'
    },
    reached: {
        id: 'medicalRecords.reached',
        defaultMessage: 'Alcançado'
    },
    notReached: {
        id: 'medicalRecords.notReached',
        defaultMessage: 'Não Alcançado'
    },
    discontinued: {
        id: 'medicalRecords.discontinued',
        defaultMessage: 'Descontinuado'
    },
    deleted: {
        id: 'medicalRecords.deleted',
        defaultMessage: 'Excluído'
    },
    objectivesInProgressDescription: {
        id: 'medicalRecords.objectivesInProgressDescription',
        defaultMessage: 'Objetivos que estão em andamento.'
    },
    objectivesReachedDescription: {
        id: 'medicalRecords.objectivesReachedDescription',
        defaultMessage: 'Objetivos que foram atingidos.'
    },
    objectivesNotReachedDescription: {
        id: 'medicalRecords.objectivesNotReachedDescription',
        defaultMessage: 'Objetivos que não foram atingidos.'
    },
    objectivesDiscontinuedDescription: {
        id: 'medicalRecords.objectivesDiscontinuedDescription',
        defaultMessage: 'Objetivos removidos do plano.'
    },
    objectivesDeletedDescription: {
        id: 'medicalRecords.objectivesDeletedDescription',
        defaultMessage: 'Objetivos excluídos do plano.'
    },
    average: {
        id: 'medicalRecords.average',
        defaultMessage: 'Média'
    },
    objectivesEvolutionHistory: {
        id: 'medicalRecords.objectivesEvolutionHistory',
        defaultMessage: 'Histórico de evolução dos objetivos'
    },
    downloadImage: {
        id: 'medicalRecords.downloadImage',
        defaultMessage: 'Baixar imagem'
    },
    objectivesDistribution: {
        id: 'medicalRecords.objectivesDistribution',
        defaultMessage: 'Distribuição dos Objetivos'
    },
    total: {
        id: 'medicalRecords.total',
        defaultMessage: 'Total'
    },
    objectivesOverview: {
        id: 'medicalRecords.objectivesOverview',
        defaultMessage: 'Visão Geral dos Objetivos'
    },
    progress: {
        id: 'medicalRecords.progress',
        defaultMessage: 'Progresso'
    },
    generalProgress: {
        id: 'medicalRecords.generalProgress',
        defaultMessage: 'Progresso Geral'
    },
    objectives: {
        id: 'medicalRecords.objectives',
        defaultMessage: 'Objetivos'
    },
    notIdentified: {
        id: 'medicalRecords.notIdentified',
        defaultMessage: 'Campo não identificado'
    },
    bodyMap: {
        id: 'medicalRecords.bodyMap',
        defaultMessage: 'Mapa corporal'
    },
    graph: {
        id: 'medicalRecords.graph',
        defaultMessage: 'Gráfico'
    },
    numericScale: {
        id: 'medicalRecords.numericScale',
        defaultMessage: 'Escala numérica'
    },
    report: {
        id: 'medicalRecords.report',
        defaultMessage: 'Relatório'
    },
    exercises: {
        id: 'medicalRecords.exercises',
        defaultMessage: 'Exercícios'
    },
    calculation: {
        id: 'medicalRecords.calculation',
        defaultMessage: 'Cálculo'
    },
    simpleSelection: {
        id: 'medicalRecords.simpleSelection',
        defaultMessage: 'Seleção simples'
    },
    listOfOptions: {
        id: 'medicalRecords.listOfOptions',
        defaultMessage: 'Lista de opções'
    },
    date: {
        id: 'medicalRecords.date',
        defaultMessage: 'Data'
    },
    dateAndHour: {
        id: 'medicalRecords.dateAndHour',
        defaultMessage: 'Data e Hora'
    },
    hour: {
        id: 'medicalRecords.hour',
        defaultMessage: 'Hora'
    },
    search: {
        id: 'medicalRecords.search',
        defaultMessage: 'Pesquisa'
    },
    informationLabel: {
        id: 'medicalRecords.informationLabel',
        defaultMessage: 'Rótulo de Informação'
    },
    image: {
        id: 'medicalRecords.image',
        defaultMessage: 'Imagem'
    },
    multipleChoice: {
        id: 'medicalRecords.multipleChoice',
        defaultMessage: 'Múltipla Escolha'
    },
    largeText: {
        id: 'medicalRecords.largeText',
        defaultMessage: 'Texto Grande'
    },
    period: {
        id: 'medicalRecords.period',
        defaultMessage: 'Período'
    },
    decimal: {
        id: 'medicalRecords.decimal',
        defaultMessage: 'Número Decimal'
    },
    periodDateHour: {
        id: 'medicalRecords.periodDateHour',
        defaultMessage: 'Período (Data e Hora)'
    },
    periodDate: {
        id: 'medicalRecords.periodDate',
        defaultMessage: 'Período (Data)'
    },
    periodHour: {
        id: 'medicalRecords.periodHour',
        defaultMessage: 'Período (Hora)'
    },
    float: {
        id: 'medicalRecords.float',
        defaultMessage: 'Número Flutuante'
    },
    initialAndFinalDate: {
        id: 'medicalRecords.initialAndFinalDate',
        defaultMessage: 'Data Inicial e Final'
    },
    attendanceNumber: {
        id: 'medicalRecords.attendanceNumber',
        defaultMessage: 'Nº Atend.'
    },
    attendanceDate: {
        id: 'medicalRecords.attendanceDate',
        defaultMessage: 'Data Atendimento'
    },
    releaseDate: {
        id: 'medicalRecords.releaseDate',
        defaultMessage: 'Data Liberação'
    },
    specialty: {
        id: 'medicalRecords.specialty',
        defaultMessage: 'Especialidade'
    },
    professional: {
        id: 'medicalRecords.professional',
        defaultMessage: 'Profissional'
    },
    status: {
        id: 'medicalRecords.status',
        defaultMessage: 'Status'
    },
    filters: {
        id: 'medicalRecords.filters',
        defaultMessage: 'Filtros'
    },
    authors: {
        id: 'medicalRecords.authors',
        defaultMessage: 'Autores...'
    },
    noOptions: {
        id: 'medicalRecords.noOptions',
        defaultMessage: 'Sem opções'
    },
    noResults: {
        id: 'medicalRecords.noResults',
        defaultMessage: 'Sem resultados'
    },
    comparedTo: {
        id: 'medicalRecords.comparedTo',
        defaultMessage: 'Comparado a {date}'
    },
    mySymptoms: {
        id: 'medicalRecords.mySymptoms',
        defaultMessage: 'Meus sintomas'
    },
    worsened: {
        id: 'medicalRecords.worsened',
        defaultMessage: 'pioraram'
    },
    improved: {
        id: 'medicalRecords.improved',
        defaultMessage: 'melhoraram'
    },
    pointsName: {
        id: 'medicalRecords.pointsName',
        defaultMessage: 'pontos'
    },
    untilNow: {
        id: 'medicalRecords.untilNow',
        defaultMessage: 'até agora!'
    },
    hideChart: {
        id: 'medicalRecords.hideChart',
        defaultMessage: 'Ocultar gráfico'
    },
    viewChart: {
        id: 'medicalRecords.viewChart',
        defaultMessage: 'Visualizar gráfico'
    },
    deficiency: {
        id: 'medicalRecords.deficiency',
        defaultMessage: 'Deficiência'
    },
    percentage: {
        id: 'medicalRecords.percentage',
        defaultMessage: '%'
    },
    obtained: {
        id: 'medicalRecords.obtained',
        defaultMessage: 'Obtido'
    },
    predicted: {
        id: 'medicalRecords.predicted',
        defaultMessage: 'Predito'
    },
    deficiencyHistory: {
        id: 'medicalRecords.deficiencyHistory',
        defaultMessage: 'Histórico da Deficiência'
    },
    deficiencyPerformance: {
        id: 'medicalRecords.deficiencyPerformance',
        defaultMessage: 'Desempenho da Deficiência'
    },
    noAnswersAvailable: {
        id: 'medicalRecords.noAnswersAvailable',
        defaultMessage: 'Ainda não há respostas disponíveis para gerar os gráficos'
    },
    activateGraphsMessage: {
        id: 'medicalRecords.activateGraphsMessage',
        defaultMessage: 'Para ativar os gráficos abaixo, por favor, defina o valor mínimo e máximo do campo e selecione um qualificador correspondente'
    },
    performance: {
        id: 'medicalRecords.performance',
        defaultMessage: 'Desempenho'
    },
    evolutionHistory: {
        id: 'medicalRecords.evolutionHistory',
        defaultMessage: 'Histórico de evolução'
    },
    noDataToDisplay: {
        id: 'medicalRecords.noDataToDisplay',
        defaultMessage: 'Não há dados para exibir'
    },
    interpretationAnalysis: {
        id: 'medicalRecords.interpretationAnalysis',
        defaultMessage: 'Interpretação / Análise'
    },
    biggerBetter: {
        id: 'medicalRecords.biggerBetter',
        defaultMessage: 'Maior melhor'
    },
    smallerBetter: {
        id: 'medicalRecords.smallerBetter',
        defaultMessage: 'Menor melhor'
    },
    graphInterpretationTooltip: {
        id: 'medicalRecords.graphInterpretationTooltip',
        defaultMessage: 'Os gráficos do dashboard podem ser interpretados de duas maneiras: "Maior Melhor" ou "Menor Melhor". Você pode alterar o sentido do gráfico conforme necessário.'
    },
    resultsGraphs: {
        id: 'medicalRecords.resultsGraphs',
        defaultMessage: 'Gráficos Resultados'
    },
    deficiencyGraphs: {
        id: 'medicalRecords.deficiencyGraphs',
        defaultMessage: 'Gráficos Deficiência'
    },
    resultsTable: {
        id: 'medicalRecords.resultsTable',
        defaultMessage: 'Tabela Resultados'
    },
    deficiencyTable: {
        id: 'medicalRecords.deficiencyTable',
        defaultMessage: 'Tabela Deficiência'
    },
    initialDatePlaceholder: {
        id: 'medicalRecords.initialDatePlaceholder',
        defaultMessage: 'Data Inicial'
    },
    finalDatePlaceholder: {
        id: 'medicalRecords.finalDatePlaceholder',
        defaultMessage: 'Data Final'
    },
    allSelectedPeriod: {
        id: 'medicalRecords.allSelectedPeriod',
        defaultMessage: 'Todo o período selecionado'
    },
    clearFilters: {
        id: 'medicalRecords.clearFilters',
        defaultMessage: 'Limpar Filtros'
    },
    apply: {
        id: 'medicalRecords.apply',
        defaultMessage: 'Aplicar'
    },
    compareImages: {
        id: 'medicalRecords.compareImages',
        defaultMessage: 'Comparar Imagens'
    },
    categories: {
        id: 'medicalRecords.categories',
        defaultMessage: 'Categorias...'
    },
    allModels: {
        id: 'medicalRecords.allModels',
        defaultMessage: 'Todos os modelos'
    },
    noOptions: {
        id: 'medicalRecords.noOptions',
        defaultMessage: 'Sem opções'
    },
    noResults: {
        id: 'medicalRecords.noResults',
        defaultMessage: 'Sem resultados'
    },
    searchDiseaseName: {
        id: 'medicalRecords.searchDiseaseName',
        defaultMessage: 'Busque digitando o nome da doença'
    },
    diseaseName: {
        id: 'medicalRecords.diseaseName',
        defaultMessage: 'Nome da doença'
    },
    loadingChart: {
        id: 'medicalRecords.loadingChart',
        defaultMessage: 'Carregando gráfico...'
    },
    breakPageDescription: {
        id: 'medicalRecords.breakPageDescription',
        defaultMessage: 'Aqui determina-se o inicio de uma nova pagina quando esse formulário for impresso.'
    },
    searchPlaceholder: {
        id: 'medicalRecords.searchPlaceholder',
        defaultMessage: 'Pesquisar'
    },
    moduleNamePlaceholder: {
        id: 'medicalRecords.moduleNamePlaceholder',
        defaultMessage: 'nome do módulo....'
    },
    descriptionPlaceholder: {
        id: 'medicalRecords.descriptionPlaceholder',
        defaultMessage: 'descrição....'
    },
    dragToAddField: {
        id: 'medicalRecords.dragToAddField',
        defaultMessage: 'arraste para adicionar um novo campo'
    },
    newModule: {
        id: 'medicalRecords.newModule',
        defaultMessage: 'Novo Modulo'
    },
    sectionNamePlaceholder: {
        id: 'medicalRecords.sectionNamePlaceholder',
        defaultMessage: 'nome da seção....'
    },
    newSection: {
        id: 'medicalRecords.newSection',
        defaultMessage: 'Nova Seção'
    },
    modelNamePlaceholder: {
        id: 'medicalRecords.modelNamePlaceholder',
        defaultMessage: 'Nome do Modelo'
    },
    modelDescriptionPlaceholder: {
        id: 'medicalRecords.modelDescriptionPlaceholder',
        defaultMessage: 'Descrição do Modelo'
    },
    linkModelToPatient: {
        id: 'medicalRecords.linkModelToPatient',
        defaultMessage: 'Vincular respostas deste modelo a um Paciente?'
    },
    size: {
        id: 'medicalRecords.size',
        defaultMessage: 'Tamanho:'
    },
    twoColumns: {
        id: 'medicalRecords.twoColumns',
        defaultMessage: '2 Col.'
    },
    fourColumns: {
        id: 'medicalRecords.fourColumns',
        defaultMessage: '4 Col.'
    },
    sixColumns: {
        id: 'medicalRecords.sixColumns',
        defaultMessage: '6 Col.'
    },
    eightColumns: {
        id: 'medicalRecords.eightColumns',
        defaultMessage: '8 Col.'
    },
    tenColumns: {
        id: 'medicalRecords.tenColumns',
        defaultMessage: '10 Col.'
    },
    twelveColumns: {
        id: 'medicalRecords.twelveColumns',
        defaultMessage: '12 Col.'
    },
    field: {
        id: 'medicalRecords.field',
        defaultMessage: 'Campo:'
    },
    general: {
        id: 'medicalRecords.general',
        defaultMessage: 'Geral'
    },
    design: {
        id: 'medicalRecords.design',
        defaultMessage: 'Design'
    },
    editField: {
        id: 'medicalRecords.editField',
        defaultMessage: 'Editar Campo'
    },
    usecoreField: {
        id: 'medicalRecords.usecoreField',
        defaultMessage: 'Usecore'
    },
    businessField: {
        id: 'medicalRecords.businessField',
        defaultMessage: 'Negócio'
    },
    modelFieldDescription: {
        id: 'medicalRecords.modelFieldDescription',
        defaultMessage: 'Campo padronizado na plataforma para possibilitar análise de dados, comparativo e benchmarking de resultados.'
    },
    personalFieldDescription: {
        id: 'medicalRecords.personalFieldDescription',
        defaultMessage: 'Campo criado de forma personalizada pelo usuário e que não é um modelo disponibilizado pela plataforma.'
    },
    newField: {
        id: 'medicalRecords.newField',
        defaultMessage: 'Novo campo'
    },
    testCardItem: {
        id: 'medicalRecords.testCardItem',
        defaultMessage: 'Test Card Item'
    },
    fieldsTab: {
        id: 'medicalRecords.fieldsTab',
        defaultMessage: 'Campos'
    },
    formTypeTab: {
        id: 'medicalRecords.formTypeTab',
        defaultMessage: 'Tipo de Formulário'
    },
    preview: {
        id: 'medicalRecords.preview',
        defaultMessage: 'Preview'
    },
    publish: {
        id: 'medicalRecords.publish',
        defaultMessage: 'Publicar'
    },
    save: {
        id: 'medicalRecords.save',
        defaultMessage: 'Salvar'
    },
    calculation: {
        id: 'medicalRecords.calculation',
        defaultMessage: 'Cálculo'
    },
    configureGraphDisplay: {
        id: 'medicalRecords.configureGraphDisplay',
        defaultMessage: 'Configurar a Exibição do Gráfico'
    },
    configureGraph: {
        id: 'medicalRecords.configureGraph',
        defaultMessage: 'Configurar Gráfico'
    },
    addNewField: {
        id: 'medicalRecords.addNewField',
        defaultMessage: 'Adicionar Novo Campo'
    },
    previewForm: {
        id: 'medicalRecords.previewForm',
        defaultMessage: 'Pré-visualizar Formulário'
    },
    designFormField: {
        id: 'medicalRecords.designFormField',
        defaultMessage: 'Design Form Field'
    },
    searchClientPlaceholder: {
        id: 'medicalRecords.searchClientPlaceholder',
        defaultMessage: 'Pesquise Cliente por Nome ou Documento'
    },
    clients: {
        id: 'medicalRecords.clients',
        defaultMessage: 'Clientes'
    },
    medicalRecords: {
        id: 'medicalRecords.medicalRecords',
        defaultMessage: 'Prontuários'
    },
    showDescription: {
        id: 'medicalRecords.showDescription',
        defaultMessage: 'Exibir Descrição'
    },
    searchFieldPlaceholder: {
        id: 'medicalRecords.searchFieldPlaceholder',
        defaultMessage: 'campo de pesquisa...'
    },
    loadMore: {
        id: 'medicalRecords.loadMore',
        defaultMessage: 'Carregar Mais'
    },
    dragAndDropFiles: {
        id: 'medicalRecords.dragAndDropFiles',
        defaultMessage: 'Arraste e solte alguns arquivos aqui ou clique para selecionar arquivos'
    },
    saveAndRelease: {
        id: 'medicalRecords.saveAndRelease',
        defaultMessage: 'Salvar e Liberar'
    },
    attachments: {
        id: 'medicalRecords.attachments',
        defaultMessage: 'Anexos'
    },
    download: {
        id: 'medicalRecords.download',
        defaultMessage: 'Download'
    },
    delete: {
        id: 'medicalRecords.delete',
        defaultMessage: 'Excluir'
    },
    mediaFiles: {
        id: 'medicalRecords.mediaFiles',
        defaultMessage: 'Arquivos de Mídia'
    },
    forms: {
        id: 'medicalRecords.forms',
        defaultMessage: 'Formulários'
    },
    videos: {
        id: 'medicalRecords.videos',
        defaultMessage: 'Vídeos'
    },
    writeComment: {
        id: 'medicalRecords.writeComment',
        defaultMessage: 'Escreva uma comentário...'
    },
    comment: {
        id: 'medicalRecords.comment',
        defaultMessage: 'Comentário'
    },
    addComment: {
        id: 'medicalRecords.addComment',
        defaultMessage: 'Adicionar Comentario'
    },
    certificateModel: {
        id: 'medicalRecords.certificateModel',
        defaultMessage: 'Modelo Atestado'
    },
    certificate: {
        id: 'medicalRecords.certificate',
        defaultMessage: 'Atestado'
    },
    addAnother: {
        id: 'medicalRecords.addAnother',
        defaultMessage: 'Adicionar Outro'
    },
    save: {
        id: 'medicalRecords.save',
        defaultMessage: 'Salvar'
    },
    saveAndRelease: {
        id: 'medicalRecords.saveAndRelease',
        defaultMessage: 'Salvar e Liberar'
    },
    date: {
        id: 'medicalRecords.date',
        defaultMessage: 'Data'
    },
    datePlaceholder: {
        id: 'medicalRecords.datePlaceholder',
        defaultMessage: '__/__/____'
    },
    time: {
        id: 'medicalRecords.time',
        defaultMessage: 'Horário'
    },
    exams: {
        id: 'medicalRecords.exams',
        defaultMessage: 'Exames'
    },
    noExamsFound: {
        id: 'medicalRecords.noExamsFound',
        defaultMessage: 'Nenhum exame encontrado.'
    },
    chart: {
        id: 'medicalRecords.chart',
        defaultMessage: 'Gráfico'
    },
    formModel: {
        id: 'medicalRecords.formModel',
        defaultMessage: 'Modelo de Formulário'
    },
    freeMode: {
        id: 'medicalRecords.freeMode',
        defaultMessage: 'Modo Livre'
    },
    loadingWait: {
        id: 'medicalRecords.loadingWait',
        defaultMessage: 'Carregando aguarde....'
    },
    writeDescription: {
        id: 'medicalRecords.writeDescription',
        defaultMessage: 'Escreva uma descrição....'
    },
    selectImageCategory: {
        id: 'medicalRecords.selectImageCategory',
        defaultMessage: 'Selecione a categoria da imagem'
    },
    filesAbove25mbIgnored: {
        id: 'medicalRecords.filesAbove25mbIgnored',
        defaultMessage: '(Arquivos acima de 25MB serão ignorados)'
    },
    prescriptionModel: {
        id: 'medicalRecords.prescriptionModel',
        defaultMessage: 'Modelo Prescrição'
    },
    prescription: {
        id: 'medicalRecords.prescription',
        defaultMessage: 'Prescrição'
    },
    referralModel: {
        id: 'medicalRecords.referralModel',
        defaultMessage: 'Modelo Encaminhamento'
    },
    referral: {
        id: 'medicalRecords.referral',
        defaultMessage: 'Encaminhamento'
    },
    reportModel: {
        id: 'medicalRecords.reportModel',
        defaultMessage: 'Modelo Relatorio'
    },
    report: {
        id: 'medicalRecords.report',
        defaultMessage: 'Relatório'
    },
    requestModel: {
        id: 'medicalRecords.requestModel',
        defaultMessage: 'Modelo Solicitação'
    },
    request: {
        id: 'medicalRecords.request',
        defaultMessage: 'Solicitação'
    },
    careLinesAndProjects: {
        id: 'medicalRecords.careLinesAndProjects',
        defaultMessage: 'Linhas de Cuidado / Projetos'
    },
    openNewCareLine: {
        id: 'medicalRecords.openNewCareLine',
        defaultMessage: 'Abrir Nova Linha de Cuidado'
    },
    careLineDescription: {
        id: 'medicalRecords.careLineDescription',
        defaultMessage: 'Ao abrir uma linha de cuidado, você poderá vincular atendimentos a ela.'
    },
    timeline: {
        id: 'medicalRecords.timeline',
        defaultMessage: 'Timeline'
    },
    filter: {
        id: 'medicalRecords.filter',
        defaultMessage: 'Filtro'
    },
    prescriptions: {
        id: 'medicalRecords.prescriptions',
        defaultMessage: 'Prescrições'
    },
    certificates: {
        id: 'medicalRecords.certificates',
        defaultMessage: 'Atestados'
    },
    medicalReferrals: {
        id: 'medicalRecords.medicalReferrals',
        defaultMessage: 'Encaminhamentos Médicos'
    },
    reports: {
        id: 'medicalRecords.reports',
        defaultMessage: 'Relatórios'
    },
    requests: {
        id: 'medicalRecords.requests',
        defaultMessage: 'Solicitações'
    },
    media: {
        id: 'medicalRecords.media',
        defaultMessage: 'Mídia'
    },
    attachments: {
        id: 'medicalRecords.attachments',
        defaultMessage: 'Anexos'
    },
    exams: {
        id: 'medicalRecords.exams',
        defaultMessage: 'Exames'
    },
    attendances: {
        id: 'medicalRecords.attendances',
        defaultMessage: 'Atendimentos'
    },
    printAttendances: {
        id: 'medicalRecords.printAttendances',
        defaultMessage: 'Imprimir atendimentos'
    },
    registerAbsence: {
        id: 'medicalRecords.registerAbsence',
        defaultMessage: 'Registrar Falta'
    },
    saveAndReleaseAttendance: {
        id: 'medicalRecords.saveAndReleaseAttendance',
        defaultMessage: 'Salvar e Liberar Atendimento'
    },
    attendanceSharingConfiguration: {
        id: 'medicalRecords.attendanceSharingConfiguration',
        defaultMessage: 'Configuração de compartilhamento do atendimento'
    },
    attendanceDeletion: {
        id: 'medicalRecords.attendanceDeletion',
        defaultMessage: 'Exclusão de atendimento'
    },
    formDeletion: {
        id: 'medicalRecords.formDeletion',
        defaultMessage: 'Exclusão de formulário'
    },
    selectFormsToSend: {
        id: 'medicalRecords.selectFormsToSend',
        defaultMessage: 'Selecionar formulários para o envio'
    },
    configureDashboard: {
        id: 'medicalRecords.configureDashboard',
        defaultMessage: 'Configurar Dashboard'
    },
    valueDashboards: {
        id: 'medicalRecords.valueDashboards',
        defaultMessage: 'Dashboards de Valor'
    },
    attendanceDateTime: {
        id: 'medicalRecords.attendanceDateTime',
        defaultMessage: 'Data e Horário do Atendimento'
    },
    calculationFieldError: {
        id: 'medicalRecords.calculationFieldError',
        defaultMessage: 'O prontuário contém um campo de cálculo com erro.'
    },
    allFieldsWillBeSaved: {
        id: 'medicalRecords.allFieldsWillBeSaved',
        defaultMessage: 'Todos os campos serão salvos, exceto aquele com o erro identificado.'
    },
    attendanceReleaseWarning: {
        id: 'medicalRecords.attendanceReleaseWarning',
        defaultMessage: 'Ao liberar um atendimento, ele não poderá ser alterado novamente.'
    },
    futureDateWarning: {
        id: 'medicalRecords.futureDateWarning',
        defaultMessage: 'O prontuario não pode ser liberado com data e horário futuros'
    },
    openCareLinesAndProjects: {
        id: 'medicalRecords.openCareLinesAndProjects',
        defaultMessage: 'Linhas de Cuidado / Projetos Abertas'
    },
    open: {
        id: 'medicalRecords.open',
        defaultMessage: 'Aberto'
    },
    closed: {
        id: 'medicalRecords.closed',
        defaultMessage: 'Fechado'
    },
    recordType: {
        id: 'medicalRecords.recordType',
        defaultMessage: 'Tipo de Registro'
    },
    editAbsence: {
        id: 'medicalRecords.editAbsence',
        defaultMessage: 'Editar Falta'
    },
    futureDateAbsenceWarning: {
        id: 'medicalRecords.futureDateAbsenceWarning',
        defaultMessage: 'Não pode ser registrado uma falta com data e horário futuros'
    },
    update: {
        id: 'medicalRecords.update',
        defaultMessage: 'Atualizar'
    },
    register: {
        id: 'medicalRecords.register',
        defaultMessage: 'Registrar'
    },
    hide: {
        id: 'medicalRecords.hide',
        defaultMessage: 'Ocultar'
    },
    useModelAsPersonalDashboard: {
        id: 'medicalRecords.useModelAsPersonalDashboard',
        defaultMessage: 'Usar modelo como dashboard pessoal'
    },
    confirmDeleteDashboard: {
        id: 'medicalRecords.confirmDeleteDashboard',
        defaultMessage: 'Tem certeza que deseja excluir essa dashboard?'
    },
    deleteDashboardWarning: {
        id: 'medicalRecords.deleteDashboardWarning',
        defaultMessage: 'Esta ação não pode ser desfeita.'
    },
    yes: {
        id: 'medicalRecords.yes',
        defaultMessage: 'Sim'
    },
    no: {
        id: 'medicalRecords.no',
        defaultMessage: 'Não'
    },
    createDashboard: {
        id: 'medicalRecords.createDashboard',
        defaultMessage: 'Criar Dashboard'
    },
    businessModel: {
        id: 'medicalRecords.businessModel',
        defaultMessage: 'Modelo do Negócio'
    },
    personalModel: {
        id: 'medicalRecords.personalModel',
        defaultMessage: 'Modelo do Negócio'
    },
    noDashboardsAdded: {
        id: 'medicalRecords.noDashboardsAdded',
        defaultMessage: 'Nenhuma dashboard adicionada'
    },
    visible: {
        id: 'medicalRecords.visible',
        defaultMessage: 'Visível'
    },
    hidden: {
        id: 'medicalRecords.hidden',
        defaultMessage: 'Oculto'
    },
    newIndicator: {
        id: 'medicalRecords.newIndicator',
        defaultMessage: 'Novo indicador'
    },
    editIndicator: {
        id: 'medicalRecords.editIndicator',
        defaultMessage: 'Editar indicador'
    },
    searchFields: {
        id: 'medicalRecords.searchFields',
        defaultMessage: 'Pesquisar campos'
    },
    indicatorsDashboard: {
        id: 'medicalRecords.indicatorsDashboard',
        defaultMessage: 'Indicadores Dashboard'
    },
    newIndicator2: {
        id: 'medicalRecords.newIndicator2',
        defaultMessage: 'Novo indicador'
    },
    newDashboard: {
        id: 'medicalRecords.newDashboard',
        defaultMessage: 'Nova Dashboard'
    },
    editDashboard: {
        id: 'medicalRecords.editDashboard',
        defaultMessage: 'Editar Dashboard'
    },
    editCareLine: {
        id: 'medicalRecords.editCareLine',
        defaultMessage: 'Editar linha de cuidado'
    },
    finishCareLine: {
        id: 'medicalRecords.finishCareLine',
        defaultMessage: 'Finalizar linha de cuidado'
    },
    openCareLine: {
        id: 'medicalRecords.openCareLine',
        defaultMessage: 'Abrir linha de cuidado'
    },
    linkToCareLines: {
        id: 'medicalRecords.linkToCareLines',
        defaultMessage: 'Vincular a Linhas de Cuidado'
    },
    careLine: {
        id: 'medicalRecords.careLine',
        defaultMessage: 'Linha de Cuidado'
    },
    openingDateTime: {
        id: 'medicalRecords.openingDateTime',
        defaultMessage: 'Data e Horário de abertura'
    },
    closingDateTime: {
        id: 'medicalRecords.closingDateTime',
        defaultMessage: 'Data e Horário de Finalização'
    },
    reason: {
        id: 'medicalRecords.reason',
        defaultMessage: 'Motivo'
    },
    cancel: {
        id: 'medicalRecords.cancel',
        defaultMessage: 'Cancelar'
    },
    linkCareLinesAndProjects: {
        id: 'medicalRecords.linkCareLinesAndProjects',
        defaultMessage: 'Vincule este atendimento a Linhas de Cuidado ou Projetos'
    },
    openCareLinesAndProjects: {
        id: 'medicalRecords.openCareLinesAndProjects',
        defaultMessage: 'Linhas de Cuidado / Projetos Abertas'
    },
    open: {
        id: 'medicalRecords.open',
        defaultMessage: 'Aberto'
    },
    closed: {
        id: 'medicalRecords.closed',
        defaultMessage: 'Fechado'
    },
    doNotLink: {
        id: 'medicalRecords.doNotLink',
        defaultMessage: 'Não Vincular'
    },
    link: {
        id: 'medicalRecords.link',
        defaultMessage: 'Vincular'
    },
    noIndicatorsSelected: {
        id: 'medicalRecords.noIndicatorsSelected',
        defaultMessage: 'Nenhum indicador selecionado'
    },
    loadingGraph: {
        id: 'medicalRecords.loadingGraph',
        defaultMessage: 'Carregando gráfico...'
    },
    confirmDeleteAttendance: {
        id: 'medicalRecords.confirmDeleteAttendance',
        defaultMessage: 'Ao confirmar, você excluirá o atendimento atual. Deseja continuar?'
    },
    confirmDeleteForm: {
        id: 'medicalRecords.confirmDeleteForm',
        defaultMessage: 'Ao confirmar, você excluirá o formulário selecionado. Deseja continuar?'
    },
    collectRemoteResponses: {
        id: 'medicalRecords.collectRemoteResponses',
        defaultMessage: 'Coletar respostas à distância'
    },
    collectResponsesDescription1: {
        id: 'medicalRecords.collectResponsesDescription1',
        defaultMessage: 'Gere um link para coletar respostas à distância de seus pacientes por meio de Formulários, PROMs, PREMs e Questionários.'
    },
    collectResponsesDescription2: {
        id: 'medicalRecords.collectResponsesDescription2',
        defaultMessage: 'Você pode selecionar quantos instrumentos desejar para que seu paciente responda.'
    },
    collectResponsesDescription3: {
        id: 'medicalRecords.collectResponsesDescription3',
        defaultMessage: 'O link gerado é exclusivo para cada paciente e tem validade de até 30 dias.'
    },
    sections: {
        id: 'medicalRecords.sections',
        defaultMessage: 'Seções'
    },
    required: {
        id: 'medicalRecords.required',
        defaultMessage: 'Obrigatório'
    },
    copy: {
        id: 'medicalRecords.copy',
        defaultMessage: 'Copiar'
    },
    sendLinkWhatsapp: {
        id: 'medicalRecords.sendLinkWhatsapp',
        defaultMessage: 'Enviar link via whatsapp'
    },
    generateLink: {
        id: 'medicalRecords.generateLink',
        defaultMessage: 'Gerar link'
    },
    linkExpiration: {
        id: 'medicalRecords.linkExpiration',
        defaultMessage: 'Data e Hora de Expiração'
    },
    generatedLink: {
        id: 'medicalRecords.generatedLink',
        defaultMessage: 'Link Gerado'
    },
    regenerateLink: {
        id: 'medicalRecords.regenerateLink',
        defaultMessage: 'Regenerar Link'
    },
    linkStatus: {
        id: 'medicalRecords.linkStatus',
        defaultMessage: 'Status'
    },
    linkActive: {
        id: 'medicalRecords.linkActive',
        defaultMessage: 'Ativo'
    },
    linkExpired: {
        id: 'medicalRecords.linkExpired',
        defaultMessage: 'Expirado'
    },
    generatingLinks: {
        id: 'medicalRecords.generatingLinks',
        defaultMessage: 'Gerando os links'
    },
    completelyAnswered: {
        id: 'medicalRecords.completelyAnswered',
        defaultMessage: 'Formulário Completamente Respondido'
    },
    partiallyAnswered: {
        id: 'medicalRecords.partiallyAnswered',
        defaultMessage: 'Formulário Parcialmente Respondido'
    },
    responseRulesTooltip: {
        id: 'medicalRecords.responseRulesTooltip',
        defaultMessage: 'Define se o formulário deve ser preenchido completamente ou parcialmente'
    },
    privateAttendance: {
        id: 'medicalRecords.privateAttendance',
        defaultMessage: 'Este atendimento é privado e somente você pode visualizá-lo'
    },
    groupAccessAttendance: {
        id: 'medicalRecords.groupAccessAttendance',
        defaultMessage: 'Somente os membros do grupo de acesso definido podem visualizar este atendimento'
    },
    publicAttendance: {
        id: 'medicalRecords.publicAttendance',
        defaultMessage: 'Este atendimento é público e pode ser visualizado por todos'
    },
    makePublic: {
        id: 'medicalRecords.makePublic',
        defaultMessage: 'Tornar público'
    },
    shareWithEveryone: {
        id: 'medicalRecords.shareWithEveryone',
        defaultMessage: 'Compartilhar atendimento com todos'
    },
    shareWithGroup: {
        id: 'medicalRecords.shareWithGroup',
        defaultMessage: 'Compartilhar com um grupo de acesso específico'
    },
    shareWith: {
        id: 'medicalRecords.shareWith',
        defaultMessage: 'Compartilhar com:'
    },

    medicalRecord: {
        id: 'medicalRecords.medicalRecord',
        defaultMessage: 'Prontuário'
    },
    careLinePlaceholder: {
        id: 'medicalRecords.careLinePlaceholder',
        defaultMessage: 'Linha de cuidado'
    },
    attendanceDateAbrev: {
        id: 'medicalRecords.attendanceDateAbrev',
        defaultMessage: 'Data do Atend.:'
    },
    answeredByPatient: {
        id: 'medicalRecords.answeredByPatient',
        defaultMessage: 'Respondido pelo Paciente'
    },
    patientAnswerPending: {
        id: 'medicalRecords.patientAnswerPending',
        defaultMessage: 'Resp. Paciente Pende...'
    },
    closedAndReleased: {
        id: 'medicalRecords.closedAndReleased',
        defaultMessage: 'Fechado e Liberado'
    },
    printAttendance: {
        id: 'medicalRecords.printAttendance',
        defaultMessage: 'Imprimir atendimento'
    },
    deleteAttendance: {
        id: 'medicalRecords.deleteAttendance',
        defaultMessage: 'Excluir atendimento'
    },
    everyoneCanViewAttendance: {
        id: 'medicalRecords.everyoneCanViewAttendance',
        defaultMessage: 'Todos podem visualizar este atendimento'
    },
    onlyYouCanViewAttendance: {
        id: 'medicalRecords.onlyYouCanViewAttendance',
        defaultMessage: 'Somente você pode visualizar este atendimento'
    },
    groupMembersCanViewAttendance: {
        id: 'medicalRecords.groupMembersCanViewAttendance',
        defaultMessage: 'Todos os membros do grupo de acesso podem visualizar este atendimento'
    },
    everyoneWillViewAfterRelease: {
        id: 'medicalRecords.everyoneWillViewAfterRelease',
        defaultMessage: 'Todos poderão visualizar este atendimento após a liberação'
    },
    onlyYouWillViewAfterRelease: {
        id: 'medicalRecords.onlyYouWillViewAfterRelease',
        defaultMessage: 'Somente você poderá visualizar este atendimento após a liberação'
    },
    groupMembersWillViewAfterRelease: {
        id: 'medicalRecords.groupMembersWillViewAfterRelease',
        defaultMessage: 'Todos os membros do grupo de acesso definido poderão visualizar este atendimento após a liberação'
    },
    careLinesAndSummary: {
        id: 'medicalRecords.careLinesAndSummary',
        defaultMessage: 'Linhas de Cuidado / Resumo'
    },
    album: {
        id: 'medicalRecords.album',
        defaultMessage: 'Álbum'
    },
    user: {
        id: 'medicalRecords.user',
        defaultMessage: 'Usuário'
    },
    details: {
        id: 'medicalRecords.details',
        defaultMessage: 'Detalhes'
    },
    phone: {
        id: 'medicalRecords.phone',
        defaultMessage: 'Telefone:'
    },
    cellphone: {
        id: 'medicalRecords.cellphone',
        defaultMessage: 'Celular:'
    },
    pending: {
        id: 'medicalRecords.pending',
        defaultMessage: 'Pendente'
    },
    completed: {
        id: 'medicalRecords.completed',
        defaultMessage: 'Concluido'
    },
    partial: {
        id: 'medicalRecords.partial',
        defaultMessage: 'Parcial'
    },
    contentCopied: {
        id: 'medicalRecords.contentCopied',
        defaultMessage: 'Conteúdo copiado para a área de transferência!'
    },
    viewGraphics: {
        id: 'medicalRecords.viewGraphics',
        defaultMessage: 'Visualizar Gráficos'
    },
    birthdate: {
        id: 'medicalRecords.birthdate',
        defaultMessage: 'Data de Nascimento:'
    },
    age: {
        id: 'medicalRecords.age',
        defaultMessage: 'Idade:'
    },
    profession: {
        id: 'medicalRecords.profession',
        defaultMessage: 'Profissão:'
    },
    maritalStatus: {
        id: 'medicalRecords.maritalStatus',
        defaultMessage: 'Estado Civil:'
    },
    comparativeMode: {
        id: 'medicalRecords.comparativeMode',
        defaultMessage: 'Modo Comparativo'
    },
    initialAnswerWelcome: {
        id: 'medicalRecords.initialAnswerWelcome',
        defaultMessage: 'Por favor, dedique um momento para preencher os formulários e questionários abaixo, eles fazem parte da sua avaliação e direcionam o seu tratamento e acompanhamento.'
    },
    initialAnswerConfidentiality: {
        id: 'medicalRecords.initialAnswerConfidentiality',
        defaultMessage: 'Confidencialidade: Suas respostas são confidenciais, protegidas e salvas automaticamente enquanto você avança'
    },
    initialAnswerFlexibility: {
        id: 'medicalRecords.initialAnswerFlexibility',
        defaultMessage: 'Flexibilidade: Pause e retome o preenchimento quando desejar; nosso sistema identifica seu último ponto de progresso.'
    },
    initialAnswerDataProtection: {
        id: 'medicalRecords.initialAnswerDataProtection',
        defaultMessage: 'Proteção de Dados: Respeitamos sua privacidade. Todos os dados coletados estão em conformidade com a LGPD e são usados exclusivamente para seu tratamento e cuidados de saúde.'
    },
    initialAnswerCongratulations: {
        id: 'medicalRecords.initialAnswerCongratulations',
        defaultMessage: 'Parabéns! Você concluiu todos os formulários necessários. Não há mais tarefas pendentes no momento.'
    },
    initialAnswerContact: {
        id: 'medicalRecords.initialAnswerContact',
        defaultMessage: 'Em caso de dúvidas ou necessidade de assistência, entre em contato.'
    },
    initialAnswerThanks: {
        id: 'medicalRecords.initialAnswerThanks',
        defaultMessage: 'Agradeço sua colaboração.'
    },
    formNotAvailable: {
        id: 'medicalRecords.formNotAvailable',
        defaultMessage: 'Formulário não disponível'
    },
    formNotAvailableDescription: {
        id: 'medicalRecords.formNotAvailableDescription',
        defaultMessage: 'O formulário que está tentando acessar foi removido ou o seu compartilhamento foi encerrado ou expirou. Entre em contato com o profissional ou empresa que compartilhou com você'
    },
    formsPending: {
        id: 'medicalRecords.formsPending',
        defaultMessage: 'Formulários pendentes'
    },
    secureEnvironment: {
        id: 'medicalRecords.secureEnvironment',
        defaultMessage: 'Ambiente seguro'
    },
    start: {
        id: 'medicalRecords.start',
        defaultMessage: 'Iniciar'
    },
    loading: {
        id: 'medicalRecords.loading',
        defaultMessage: 'Configurando ambiente para acesso seguro...'
    },
    newCategory: {
        id: 'medicalRecords.newCategory',
        defaultMessage: 'Nova Categoria'
    },
    categoryImages: {
        id: 'medicalRecords.categoryImages',
        defaultMessage: 'Categorias de Imagens e Fotos'
    },
    preCustomerRegistration: {
        id: 'medicalRecords.preCustomerRegistration',
        defaultMessage: 'Pré-Cadastro de Cliente'
    },
    newPreCustomerRegistration: {
        id: 'medicalRecords.newPreCustomerRegistration',
        defaultMessage: 'Novo Pré-Cadastro'
    },
    editPreCustomerRegistration: {
        id: 'medicalRecords.editPreCustomerRegistration',
        defaultMessage: 'Editar Pré-Cadastro'
    },
    preCustomerName: {
        id: 'medicalRecords.preCustomerName',
        defaultMessage: 'Nome'
    },
    preCustomerEmail: {
        id: 'medicalRecords.preCustomerEmail',
        defaultMessage: 'E-mail'
    },
    preCustomerPhone: {
        id: 'medicalRecords.preCustomerPhone',
        defaultMessage: 'Telefone'
    },
    preCustomerDocument: {
        id: 'medicalRecords.preCustomerDocument',
        defaultMessage: 'Documento'
    },
    preCustomerBirthDate: {
        id: 'medicalRecords.preCustomerBirthDate',
        defaultMessage: 'Data de Nascimento'
    },
    preCustomerAddress: {
        id: 'medicalRecords.preCustomerAddress',
        defaultMessage: 'Endereço'
    },
    preCustomerObservations: {
        id: 'medicalRecords.preCustomerObservations',
        defaultMessage: 'Observações'
    },
    categoryName: {
        id: 'medicalRecords.categoryName',
        defaultMessage: 'Nome da Categoria'
    },
    searchByName: {
        id: 'medicalRecords.searchByName',
        defaultMessage: 'procurar pelo nome'
    },
    saving: {
        id: 'medicalRecords.saving',
        defaultMessage: 'Salvando...'
    },
    newCoreLine: {
        id: 'medicalRecords.newCoreLine',
        defaultMessage: 'Nova Linha de Cuidado'
    },
    editCoreLine: {
        id: 'medicalRecords.editCoreLine',
        defaultMessage: 'Editar Linha de Cuidado'
    },
    createNewCoreLine: {
        id: 'medicalRecords.createNewCoreLine',
        defaultMessage: 'Criar Nova Linha de Cuidado'
    },
    coreLines: {
        id: 'medicalRecords.coreLines',
        defaultMessage: 'Linhas de Cuidado'
    },
    coreLineName: {
        id: 'medicalRecords.coreLineName',
        defaultMessage: 'Nome da Linha de Cuidado'
    },
    origin: {
        id: 'medicalRecords.origin',
        defaultMessage: 'Origem'
    },
    personal: {
        id: 'medicalRecords.personal',
        defaultMessage: 'Negócio'
    },
    usecore: {
        id: 'medicalRecords.usecore',
        defaultMessage: 'Usecore'
    },
    filters: {
        id: 'medicalRecords.filters',
        defaultMessage: 'Filtros'
    },
    newDashboardModel: {
        id: 'medicalRecords.newDashboardModel',
        defaultMessage: 'Novo Modelo de Dashboard'
    },
    duplicate: {
        id: 'medicalRecords.duplicate',
        defaultMessage: 'Duplicar'
    },
    dashboardModels: {
        id: 'medicalRecords.dashboardModels',
        defaultMessage: 'Modelos de Dashboard'
    },
    dashboardName: {
        id: 'medicalRecords.dashboardName',
        defaultMessage: 'Nome da Dashboard'
    },
    configuration: {
        id: 'medicalRecords.configuration',
        defaultMessage: 'Configuração'
    },
    basicInformation: {
        id: 'medicalRecords.basicInformation',
        defaultMessage: 'Informações Básicas'
    },
    inactive: {
        id: 'medicalRecords.inactive',
        defaultMessage: 'Inativo'
    },
    active: {
        id: 'medicalRecords.active',
        defaultMessage: 'Ativo'
    },
    exerciseName: {
        id: 'medicalRecords.exerciseName',
        defaultMessage: 'Nome do Exercício'
    },
    exerciseNumber: {
        id: 'medicalRecords.exerciseNumber',
        defaultMessage: 'Número do Exercício'
    },
    exerciseCategories: {
        id: 'medicalRecords.exerciseCategories',
        defaultMessage: 'Categorias do Exercício'
    },
    selectCategories: {
        id: 'medicalRecords.selectCategories',
        defaultMessage: 'Selecione as categorías'
    },
    exerciseParameters: {
        id: 'medicalRecords.exerciseParameters',
        defaultMessage: 'Parâmetros / Prescrição do Exercício'
    },
    exerciseParametersDescription: {
        id: 'medicalRecords.exerciseParametersDescription',
        defaultMessage: 'Selecione os itens que deseja responder, em seu prontuário, ao selecionar este exercício.'
    },
    exerciseMonitoring: {
        id: 'medicalRecords.exerciseMonitoring',
        defaultMessage: 'Monitorização do Exercício'
    },
    exerciseMonitoringDescription: {
        id: 'medicalRecords.exerciseMonitoringDescription',
        defaultMessage: 'Selecione os itens que deseja responder, em seu prontuário, ao selecionar este exercício.'
    },
    fieldModelEditScreen: {
        id: 'medicalRecords.fieldModelEditScreen',
        defaultMessage: `<div>
    Este é um campo MODELO disponibilizado para o seu uso.{br}
    Modificações neste campo não são permitidas.{br}
    Caso deseje utilizar um campo com uma descrição ou opções de respostas diferentes,
    busque por outros campos modelos disponibilizados ou crie um campo personalizado.
    </div>`
    },
    blockModelEdit: {
        id: 'medicalRecords.blockModelEdit',
        defaultMessage: 'Edição Bloqueada'
    },
    addNewCategory: {
        id: 'medicalRecords.addNewCategory',
        defaultMessage: 'Adicionar nova categoria'
    },
    businessExercises: {
        id: 'medicalRecords.businessExercises',
        defaultMessage: 'Exercícios do Negócio'
    },
    addNewExercise: {
        id: 'medicalRecords.addNewExercise',
        defaultMessage: 'Adicionar Novo Exercício'
    },
    editExercise: {
        id: 'medicalRecords.editExercise',
        defaultMessage: 'Editar Exercício'
    },
    categoriesList: {
        id: 'medicalRecords.categoriesList',
        defaultMessage: 'Lista de categorias'
    },
    addCategory: {
        id: 'medicalRecords.addCategory',
        defaultMessage: 'Adicionar uma categoria'
    },
    editCategory: {
        id: 'medicalRecords.editCategory',
        defaultMessage: 'Editar uma categoria'
    },
    createNewCategory: {
        id: 'medicalRecords.createNewCategory',
        defaultMessage: 'Criar nova categoria'
    },
    exercises: {
        id: 'medicalRecords.exercises',
        defaultMessage: 'Exercícios'
    },
    showCategories: {
        id: 'medicalRecords.showCategories',
        defaultMessage: 'Ver categorias'
    },
    previeView: {
        id: 'medicalRecords.previeView',
        defaultMessage: 'Visualizar'
    },
    businessFields: {
        id: 'medicalRecords.businessFields',
        defaultMessage: 'Campos do Negócio'
    },
    globalFields: {
        id: 'medicalRecords.globalFields',
        defaultMessage: 'Campos Globais'
    },
    creationDate: {
        id: 'medicalRecords.creationDate',
        defaultMessage: 'Data de criação'
    },
    lastModificationDate: {
        id: 'medicalRecords.lastModificationDate',
        defaultMessage: 'Data de modificação'
    },
    fields: {
        id: 'medicalRecords.fields',
        defaultMessage: 'Campos'
    },
    title: {
        id: 'medicalRecords.title',
        defaultMessage: 'Título'
    },
    visibleTitle: {
        id: 'medicalRecords.visibleTitle',
        defaultMessage: 'Título Visível'
    },
    fieldType: {
        id: 'medicalRecords.fieldType',
        defaultMessage: 'Tipo de Campo'
    },
    measurementUnit: {
        id: 'medicalRecords.measurementUnit',
        defaultMessage: 'Unidade de Medida'
    },
    currentVersion: {
        id: 'medicalRecords.currentVersion',
        defaultMessage: 'Versão Atual'
    },
    createNewSubcategory: {
        id: 'medicalRecords.createNewSubcategory',
        defaultMessage: 'Criar nova subcategoria'
    },
    new: {
        id: 'medicalRecords.new',
        defaultMessage: 'Novo'
    },
    editDraft: {
        id: 'medicalRecords.editDraft',
        defaultMessage: 'Editar Rascunho'
    },
    editModel: {
        id: 'medicalRecords.editModel',
        defaultMessage: 'Editar Modelo'
    },
    duplicateModel: {
        id: 'medicalRecords.duplicateModel',
        defaultMessage: 'Duplicar Modelo'
    },
    assignToSections: {
        id: 'medicalRecords.assignToSections',
        defaultMessage: 'Atribuir às seções'
    },
    drafts: {
        id: 'medicalRecords.drafts',
        defaultMessage: 'Rascunhos'
    },
    globalModels: {
        id: 'medicalRecords.globalModels',
        defaultMessage: 'Modelos da Usecore'
    },
    businessModels: {
        id: 'medicalRecords.businessModels',
        defaultMessage: 'Modelos do Negócio'
    },
    promRequests: {
        id: 'medicalRecords.promRequests',
        defaultMessage: 'Solicitações PROM'
    },
    newPromRequest: {
        id: 'medicalRecords.newPromRequest',
        defaultMessage: 'Nova Solicitação PROM'
    },
    promRequestDescription: {
        id: 'medicalRecords.promRequestDescription',
        defaultMessage: 'Solicite a inclusão de um novo PROM ao sistema'
    },
    promRequestFullName: {
        id: 'medicalRecords.promRequestFullName',
        defaultMessage: 'Nome completo do instrumento'
    },
    promRequestAcronym: {
        id: 'medicalRecords.promRequestAcronym',
        defaultMessage: 'Sigla'
    },
    promRequestApplicationArea: {
        id: 'medicalRecords.promRequestApplicationArea',
        defaultMessage: 'Área de aplicação'
    },
    promRequestObservations: {
        id: 'medicalRecords.promRequestObservations',
        defaultMessage: 'Observações adicionais'
    },
    promRequestScientificArticle: {
        id: 'medicalRecords.promRequestScientificArticle',
        defaultMessage: 'Artigo científico (obrigatório)'
    },
    promRequestPromForm: {
        id: 'medicalRecords.promRequestPromForm',
        defaultMessage: 'Formulário PROM (obrigatório)'
    },
    promRequestManual: {
        id: 'medicalRecords.promRequestManual',
        defaultMessage: 'Manual (opcional)'
    },
    promRequestValidationArticle: {
        id: 'medicalRecords.promRequestValidationArticle',
        defaultMessage: 'Artigos de validação (opcional)'
    },
    promRequestUploadHint: {
        id: 'medicalRecords.promRequestUploadHint',
        defaultMessage: 'Clique ou arraste o arquivo aqui (PDF, máx. 20MB)'
    },
    promRequestSubmit: {
        id: 'medicalRecords.promRequestSubmit',
        defaultMessage: 'Enviar Solicitação'
    },
    promRequestCancel: {
        id: 'medicalRecords.promRequestCancel',
        defaultMessage: 'Cancelar'
    },
    promStatusAguardandoProcessamento: {
        id: 'medicalRecords.promStatusAguardandoProcessamento',
        defaultMessage: 'Aguardando Processamento'
    },
    promStatusEmProcessamento: {
        id: 'medicalRecords.promStatusEmProcessamento',
        defaultMessage: 'Em Processamento'
    },
    promStatusEmPreparacaoRevisao: {
        id: 'medicalRecords.promStatusEmPreparacaoRevisao',
        defaultMessage: 'Em Preparação para Revisão'
    },
    promStatusAguardandoRevisao: {
        id: 'medicalRecords.promStatusAguardandoRevisao',
        defaultMessage: 'Processado - Aguardando Revisão'
    },
    promStatusEmRevisaoInterna: {
        id: 'medicalRecords.promStatusEmRevisaoInterna',
        defaultMessage: 'Em Revisão Interna'
    },
    promStatusAjustesSolicitados: {
        id: 'medicalRecords.promStatusAjustesSolicitados',
        defaultMessage: 'Ajustes Solicitados'
    },
    promStatusPublicado: {
        id: 'medicalRecords.promStatusPublicado',
        defaultMessage: 'Publicado'
    },
    promStatusRejeitado: {
        id: 'medicalRecords.promStatusRejeitado',
        defaultMessage: 'Rejeitado'
    },
    promActionApprove: {
        id: 'medicalRecords.promActionApprove',
        defaultMessage: 'Aprovar'
    },
    promActionSendToManagerValidation: {
        id: 'medicalRecords.promActionSendToManagerValidation',
        defaultMessage: 'Enviar para Validação do Manager'
    },
    promEditorBlockedMessage: {
        id: 'medicalRecords.promEditorBlockedMessage',
        defaultMessage: 'Rascunho enviado. Aguardando revisão interna.'
    },
    promActionRequestReextraction: {
        id: 'medicalRecords.promActionRequestReextraction',
        defaultMessage: 'Solicitar Reextração'
    },
    promActionRequestAdjustments: {
        id: 'medicalRecords.promActionRequestAdjustments',
        defaultMessage: 'Solicitar Ajustes'
    },
    promActionReject: {
        id: 'medicalRecords.promActionReject',
        defaultMessage: 'Rejeitar'
    },
    promActionPublish: {
        id: 'medicalRecords.promActionPublish',
        defaultMessage: 'Publicar'
    },
    promReviewTitle: {
        id: 'medicalRecords.promReviewTitle',
        defaultMessage: 'Revisar Solicitação'
    },
    promEditorTitle: {
        id: 'medicalRecords.promEditorTitle',
        defaultMessage: 'Revisar PROM'
    },
    promEditorClose: {
        id: 'medicalRecords.promEditorClose',
        defaultMessage: 'Fechar'
    },
    promEditorRequestReextractionComments: {
        id: 'medicalRecords.promEditorRequestReextractionComments',
        defaultMessage: 'Descreva os ajustes necessários...'
    },
    promCommentsLabel: {
        id: 'medicalRecords.promCommentsLabel',
        defaultMessage: 'Comentários / Justificativa'
    },
    promReviewSuccess: {
        id: 'medicalRecords.promReviewSuccess',
        defaultMessage: 'Revisão enviada com sucesso'
    },
    promCreateSuccess: {
        id: 'medicalRecords.promCreateSuccess',
        defaultMessage: 'Solicitação criada com sucesso'
    },
    newForm: {
        id: 'medicalRecords.newForm',
        defaultMessage: 'Novo Fomulário'
    },
    startBlankForm: {
        id: 'medicalRecords.startBlankForm',
        defaultMessage: 'Comece um formulário em branco'
    },
    searchForm: {
        id: 'medicalRecords.searchForm',
        defaultMessage: 'Pesquisar formulário...'
    },
    favorites: {
        id: 'medicalRecords.favorites',
        defaultMessage: 'Favoritos'
    },
    favoritesTooltip: {
        id: 'medicalRecords.favoritesTooltip',
        defaultMessage: 'Ao marcar um modelo como favorito, você habilita sua utilização na configuração das seções do prontuário.'
    },
    noPermissionTooltip: {
        id: 'medicalRecords.noPermissionTooltip',
        defaultMessage: 'Você não tem permissão para selecionar este Modelo'
    },
    noAccessTooltip: {
        id: 'medicalRecords.noAccessTooltip',
        defaultMessage: 'Você não tem permissão para acessar este Modelo. Por favor, entre em contato com o administrador do sistema para obter assistência ou fale com o suporte da USECORE para verificar como ter o acesso.'
    },
    paid: {
        id: 'medicalRecords.paid',
        defaultMessage: 'Pago'
    },
    free: {
        id: 'medicalRecords.free',
        defaultMessage: 'Grátis'
    },
    private: {
        id: 'medicalRecords.private',
        defaultMessage: 'Privado'
    },
    public: {
        id: 'medicalRecords.public',
        defaultMessage: 'Público'
    },
    secret: {
        id: 'medicalRecords.secret',
        defaultMessage: 'Secreto'
    },
    previewGlobalForm: {
        id: 'medicalRecords.previewGlobalForm',
        defaultMessage: 'Pré-visualizar Formulário Global'
    },
    createdBy: {
        id: 'medicalRecords.createdBy',
        defaultMessage: 'Criado Por'
    },
    medicalRecordConfiguration: {
        id: 'medicalRecords.medicalRecordConfiguration',
        defaultMessage: 'Configuração Prontuario'
    },
    multiprofessionalMedicalRecord: {
        id: 'medicalRecords.multiprofessionalMedicalRecord',
        defaultMessage: 'Prontuário Multiprofissional - Os prontuários são compartilhados entre todos os profissionais do Workspace'
    },
    medicalRecordSharing: {
        id: 'medicalRecords.medicalRecordSharing',
        defaultMessage: 'Compartilhamento de Prontuários entre Workspaces'
    },
    standardizeSections: {
        id: 'medicalRecords.standardizeSections',
        defaultMessage: 'Padronizar Seções do Prontuário para todos os Profissionais'
    },
    attendanceSharingControl: {
        id: 'medicalRecords.attendanceSharingControl',
        defaultMessage: 'Controle de Compartilhamento de Atendimentos'
    },
    noControl: {
        id: 'medicalRecords.noControl',
        defaultMessage: 'Sem Controle'
    },
    withControl: {
        id: 'medicalRecords.withControl',
        defaultMessage: 'Com Controle'
    },
    newQualifier: {
        id: 'medicalRecords.newQualifier',
        defaultMessage: 'Novo Qualificador'
    },
    editQualifier: {
        id: 'medicalRecords.editQualifier',
        defaultMessage: 'Editar Qualificador'
    },
    createQualifier: {
        id: 'medicalRecords.createQualifier',
        defaultMessage: 'Criar Qualificador'
    },
    qualifiers: {
        id: 'medicalRecords.qualifiers',
        defaultMessage: 'Qualificadores'
    },
    careLines: {
        id: 'medicalRecords.careLines',
        defaultMessage: 'Linhas de Cuidado'
    },
    patients: {
        id: 'medicalRecords.patients',
        defaultMessage: 'Pacientes'
    },
    qualifierName: {
        id: 'medicalRecords.qualifierName',
        defaultMessage: 'Nome do Qualificador'
    },
    origin: {
        id: 'medicalRecords.origin',
        defaultMessage: 'Origem'
    },
    personal: {
        id: 'medicalRecords.personal',
        defaultMessage: 'Negócio'
    },
    usecore: {
        id: 'medicalRecords.usecore',
        defaultMessage: 'Usecore'
    },
    all: {
        id: 'medicalRecords.all',
        defaultMessage: 'Todos'
    },
    order: {
        id: 'medicalRecords.order',
        defaultMessage: 'Ordem'
    },
    noGlobalModels: {
        id: 'medicalRecords.noGlobalModels',
        defaultMessage: 'Você ainda não possui formulários globais favoritos. Por favor, selecione formulários na tabela, e eles serão exibidos aqui.'
    },
    models: {
        id: 'medicalRecords.models',
        defaultMessage: 'Modelos'
    },
    use: {
        id: 'medicalRecords.use',
        defaultMessage: 'Utilizar'
    },
    model: {
        id: 'medicalRecords.model',
        defaultMessage: 'modelo'
    },
    editSection: {
        id: 'medicalRecords.editSection',
        defaultMessage: 'Editar Seção'
    },
    fieldTypeNumber: {
        id: 'medicalRecords.fieldTypeNumber',
        defaultMessage: 'Número'
    },
    fieldTypeText: {
        id: 'medicalRecords.fieldTypeText',
        defaultMessage: 'Texto'
    },
    fieldTypeDateTime: {
        id: 'medicalRecords.fieldTypeDateTime',
        defaultMessage: 'Data e Hora'
    },
    fieldTypeDate: {
        id: 'medicalRecords.fieldTypeDate',
        defaultMessage: 'Data'
    },
    fieldTypeTime: {
        id: 'medicalRecords.fieldTypeTime',
        defaultMessage: 'Hora'
    },
    fieldTypePeriod: {
        id: 'medicalRecords.fieldTypePeriod',
        defaultMessage: 'Periodo'
    },
    fieldTypeInfoLabel: {
        id: 'medicalRecords.fieldTypeInfoLabel',
        defaultMessage: 'Rótulo de Informação'
    },
    fieldTypeSearch: {
        id: 'medicalRecords.fieldTypeSearch',
        defaultMessage: 'Pesquisa'
    },
    fieldTypeOptionList: {
        id: 'medicalRecords.fieldTypeOptionList',
        defaultMessage: 'Lista de Opções'
    },
    fieldTypeSimpleSelection: {
        id: 'medicalRecords.fieldTypeSimpleSelection',
        defaultMessage: 'Seleção Simples'
    },
    fieldTypeMultipleChoice: {
        id: 'medicalRecords.fieldTypeMultipleChoice',
        defaultMessage: 'Múltipla Escolha'
    },
    fieldTypeNumericScale: {
        id: 'medicalRecords.fieldTypeNumericScale',
        defaultMessage: 'Escala Numérica'
    },
    fieldTypeReport: {
        id: 'medicalRecords.fieldTypeReport',
        defaultMessage: 'Relatório'
    },
    fieldTypeCalculation: {
        id: 'medicalRecords.fieldTypeCalculation',
        defaultMessage: 'Cálculo'
    },
    fieldTypeExercise: {
        id: 'medicalRecords.fieldTypeExercise',
        defaultMessage: 'Exercício'
    },
    fieldTypeChart: {
        id: 'medicalRecords.fieldTypeChart',
        defaultMessage: 'Gráfico'
    },
    fieldTypeBodyMap: {
        id: 'medicalRecords.fieldTypeBodyMap',
        defaultMessage: 'Mapa Corporal'
    },
    fieldTypeObjectives: {
        id: 'medicalRecords.fieldTypeObjectives',
        defaultMessage: 'Objetivos'
    },
    fieldTypeImages: {
        id: 'medicalRecords.fieldTypeImages',
        defaultMessage: 'Imagens e Fotos'
    },
    number: {
        id: 'medicalRecords.number',
        defaultMessage: 'Número'
    },
    floatingNumber: {
        id: 'medicalRecords.floatingNumber',
        defaultMessage: 'Número Flutuante'
    },
    decimalNumber: {
        id: 'medicalRecords.decimalNumber',
        defaultMessage: 'Número Decimal'
    },
    text: {
        id: 'medicalRecords.text',
        defaultMessage: 'Texto'
    },
    largeText: {
        id: 'medicalRecords.largeText',
        defaultMessage: 'Texto Grande'
    },
    periodDateTime: {
        id: 'medicalRecords.periodDateTime',
        defaultMessage: 'Periodo (Data e Hora)'
    },
    periodDate: {
        id: 'medicalRecords.periodDate',
        defaultMessage: 'Periodo (Data)'
    },
    periodTime: {
        id: 'medicalRecords.periodTime',
        defaultMessage: 'Periodo (Hora)'
    },
    scores: {
        id: 'medicalRecords.scores',
        defaultMessage: 'Scores'
    },
    fieldTypeTable: {
        id: 'medicalRecords.fieldTypeTable',
        defaultMessage: 'Tabela'
    },
    hangingAttendance: {
        id: 'medicalRecords.hangingAttendance',
        defaultMessage: 'Atendimentos Pendentes'
    },
    rg: {
        id: 'medicalRecords.rg',
        defaultMessage: 'RG'
    },
    email: {
        id: 'medicalRecords.email',
        defaultMessage: 'Email'
    },
    sendForm: {
        id: 'medicalRecords.sendForm',
        defaultMessage: 'Enviar Formulário'
    },
    information: {
        id: 'medicalRecords.information',
        defaultMessage: 'Informações'
    },
    dashboards: {
        id: 'medicalRecords.dashboards',
        defaultMessage: 'Dashboards'
    },
    whatsappMessage: {
        id: 'medicalRecords.whatsappMessage',
        defaultMessage: 'Olá {name}, neste link você encontrará alguns formulários para preencher.  \nEsses formulários são importantes e devem ser preenchidos com atenção e calma. \n Qualquer dúvida por favor avise: {url}'
    },
    copiedToClipboard: {
        id: 'medicalRecords.copiedToClipboard',
        defaultMessage: 'Conteúdo copiado para a área de transferência!'
    },
    copyError: {
        id: 'medicalRecords.copyError',
        defaultMessage: 'Erro ao copiar o conteúdo:'
    },
    fullyAnsweredRule: {
        id: 'medicalRecords.fullyAnsweredRule',
        defaultMessage: 'Completamente Respondido'
    },
    partiallyAnsweredRule: {
        id: 'medicalRecords.partiallyAnsweredRule',
        defaultMessage: 'Parcialmente Respondido'
    },
    namePatient: {
        id: 'medicalRecords.namePatient',
        defaultMessage: 'Nome do Paciente'
    },
    rgPatient: {
        id: 'medicalRecords.rgPatient',
        defaultMessage: 'RG do Paciente'
    },
    cpfPatient: {
        id: 'medicalRecords.cpfPatient',
        defaultMessage: 'CPF do Paciente'
    },
    phonePatient: {
        id: 'medicalRecords.phonePatient',
        defaultMessage: 'Telefone do Paciente'
    },
    cellphonePatient: {
        id: 'medicalRecords.cellphonePatient',
        defaultMessage: 'Celular do Paciente'
    },
    emailPatient: {
        id: 'medicalRecords.emailPatient',
        defaultMessage: 'Email do Paciente'
    },
    birthdatePatient: {
        id: 'medicalRecords.birthdatePatient',
        defaultMessage: 'Aniversário do Paciente'
    },
    nameProfessional: {
        id: 'medicalRecords.nameProfessional',
        defaultMessage: 'Nome do Profissional'
    },
    cpfProfessional: {
        id: 'medicalRecords.cpfProfessional',
        defaultMessage: 'CPF do Profissional'
    },
    professionProfessional: {
        id: 'medicalRecords.professionProfessional',
        defaultMessage: 'Profissão do Profissional'
    },
    councilProfessional: {
        id: 'medicalRecords.councilProfessional',
        defaultMessage: 'Conselho do Profissional'
    },
    registerProfessional: {
        id: 'medicalRecords.registerProfessional',
        defaultMessage: 'Registro do Profissional'
    },
    councilAreaProfessional: {
        id: 'medicalRecords.councilAreaProfessional',
        defaultMessage: 'UF/Região do Conselho Profissional'
    },
    attendanceDate: {
        id: 'medicalRecords.attendanceDate',
        defaultMessage: 'Data de Atendimento'
    },
    statusBarMessageRequest: {
        id: 'medicalRecords.statusBarMessageRequest',
        defaultMessage: 'Salvando alterações....'
    },
    statusBarMessageSuccess: {
        id: 'medicalRecords.statusBarMessageSuccess',
        defaultMessage: 'Todas as alterações foram salvas!'
    },
    statusBarMessageError: {
        id: 'medicalRecords.statusBarMessageError',
        defaultMessage: 'Não foi possivel salvar essas alterações!'
    },
    value: {
        id: 'medicalRecords.value',
        defaultMessage: 'Valor'
    },
    generalProgressDescription: {
        id: 'medicalRecords.generalProgressDescription',
        defaultMessage: 'Progresso geral considerando os objetivos alcançados, em andamento e não alcançados.'
    },
    removeSelection: {
        id: 'medicalRecords.removeSelection',
        defaultMessage: 'Remover seleção'
    },
    selectAll: {
        id: 'medicalRecords.selectAll',
        defaultMessage: 'Selecionar todos'
    },
    professionalData: {
        id: 'medicalRecords.professionalData',
        defaultMessage: 'Dados Profissionais'
    },
    generalDocument: {
        id: 'medicalRecords.generalDocument',
        defaultMessage: 'Documento'
    },
    documentType: {
        id: 'medicalRecords.documentType',
        defaultMessage: 'Tipo de Documento'
    },
    fieldTypeJointMobility: {
        id: 'medicalRecords.movementTypeCard.fieldTypeJointMobility',
        defaultMessage: 'Movimentos Articulares'
    },
    fieldTypeMuscleStrength: {
        id: 'medicalRecords.movementTypeCard.fieldTypeMuscleStrength',
        defaultMessage: 'Força Muscular'
    },
    addMovement: {
        id: 'medicalRecords.movementTypeCard.addMovement',
        defaultMessage: 'Adicionar {movementType}'
    },
    clickToEvaluate: {
        id: 'medicalRecords.movementTypeCard.clickToEvaluate',
        defaultMessage: 'Clique para avaliar'
    },
    remove: {
        id: 'medicalRecords.movementTypeCard.remove',
        defaultMessage: 'Remover'
    },
    measuredValue: {
        id: 'medicalRecords.movementTypeCard.measuredValue',
        defaultMessage: 'Valor medido'
    },
    maxNormal: {
        id: 'medicalRecords.movementTypeCard.maxNormal',
        defaultMessage: 'Max. Normal'
    },
    nprsPainScale: {
        id: 'medicalRecords.movementTypeCard.nprsPainScale',
        defaultMessage: 'NPRs - Escala de Dor (0-10)'
    },
    painType: {
        id: 'medicalRecords.movementTypeCard.painType',
        defaultMessage: 'Tipo de dor'
    },
    painMoment: {
        id: 'medicalRecords.movementTypeCard.painMoment',
        defaultMessage: 'Momento da dor'
    },
    endFeel: {
        id: 'medicalRecords.movementTypeCard.endFeel',
        defaultMessage: 'End-feel'
    },
    observedCompensations: {
        id: 'medicalRecords.movementTypeCard.observedCompensations',
        defaultMessage: 'Compensações observadas'
    },
    clinicalObservations: {
        id: 'medicalRecords.movementTypeCard.clinicalObservations',
        defaultMessage: 'Observações clínicas'
    },
    select: {
        id: 'medicalRecords.movementTypeCard.select',
        defaultMessage: 'Selecionar'
    },
    compensationPlaceholder: {
        id: 'medicalRecords.movementTypeCard.compensationPlaceholder',
        defaultMessage: 'Ex: Elevação de escápula, rotação de tronco...'
    },
    observationsPlaceholder: {
        id: 'medicalRecords.movementTypeCard.observationsPlaceholder',
        defaultMessage: 'Ex: Dor irradia para braço, rigidez matinal...'
    },
    emptyEndFeelAlert: {
        id: 'medicalRecords.movementTypeCard.emptyEndFeelAlert',
        defaultMessage: '⚠️ ALERTA: End-feel vazio indica possível lesão grave'
    },
    charactersCount: {
        id: 'medicalRecords.movementTypeCard.charactersCount',
        defaultMessage: '{current}/{max} caracteres'
    },
    right: {
        id: 'medicalRecords.movementTypeCard.right',
        defaultMessage: 'Direita'
    },
    left: {
        id: 'medicalRecords.movementTypeCard.left',
        defaultMessage: 'Esquerda'
    },
    unilateral: {
        id: 'medicalRecords.movementTypeCard.unilateral',
        defaultMessage: 'Unilateral'
    },
    normal: {
        id: 'medicalRecords.movementTypeCard.normal',
        defaultMessage: 'Normal'
    },
    mild: {
        id: 'medicalRecords.movementTypeCard.mild',
        defaultMessage: 'Leve'
    },
    moderate: {
        id: 'medicalRecords.movementTypeCard.moderate',
        defaultMessage: 'Moderada'
    },
    severe: {
        id: 'medicalRecords.movementTypeCard.severe',
        defaultMessage: 'Grave'
    },
    bilateral: {
        id: 'medicalRecords.movementTypeCard.bilateral',
        defaultMessage: 'Bilateral'
    },
    noLaterality: {
        id: 'medicalRecords.movementTypeCard.noLaterality',
        defaultMessage: 'Sem Lateralidade'
    },
    asymmetry: {
        id: 'medicalRecords.movementTypeCard.asymmetry',
        defaultMessage: 'Assimetria'
    },
    rightSide: {
        id: 'medicalRecords.movementTypeCard.rightSide',
        defaultMessage: 'Lado Direito'
    },
    leftSide: {
        id: 'medicalRecords.movementTypeCard.leftSide',
        defaultMessage: 'Lado Esquerdo'
    },
    unilateralAssessment: {
        id: 'medicalRecords.movementTypeCard.unilateralAssessment',
        defaultMessage: 'Avaliação Unilateral'
    },
    asymmetryDetected: {
        id: 'medicalRecords.movementTypeCard.asymmetryDetected',
        defaultMessage: 'Assimetria Detectada'
    },
    type: {
        id: 'medicalRecords.movementTypeCard.type',
        defaultMessage: 'Tipo'
    },
    maxValue: {
        id: 'medicalRecords.movementTypeCard.maxValue',
        defaultMessage: 'Max'
    },
    selectAnatomicalArea: {
        id: 'medicalRecords.movementTypeCard.selectAnatomicalArea',
        defaultMessage: 'Selecionar Área Anatômica'
    },
    professionalAssessment: {
        id: 'medicalRecords.movementTypeCard.professionalAssessment',
        defaultMessage: 'Avaliação profissional de amplitude de movimento com identificação de assimetrias e geração de relatório'
    },
    assessment: {
        id: 'medicalRecords.movementTypeCard.assessment',
        defaultMessage: 'Avaliação'
    },
    dashboard: {
        id: 'medicalRecords.movementTypeCard.dashboard',
        defaultMessage: 'Dashboard'
    },
    movements: {
        id: 'medicalRecords.movementTypeCard.movements',
        defaultMessage: 'movimentos'
    },
    noDataAvailable: {
        id: 'medicalRecords.movementTypeCard.noDataAvailable',
        defaultMessage: 'Nenhum dado disponível'
    },
    selectAreaHelp: {
        id: 'medicalRecords.movementTypeCard.selectAreaHelp',
        defaultMessage: 'Selecione uma área anatômica para visualizar os movimentos disponíveis'
    },
    studyName: {
        id: 'medicalRecords.asymmetry.studyName',
        defaultMessage: 'Nome do Estudo',
    },
    reference: {
        id: 'medicalRecords.asymmetry.reference',
        defaultMessage: 'Referência (autor & ano)',
    },
    doi: {
        id: 'medicalRecords.asymmetry.doi',
        defaultMessage: 'DOI',
    },
    leftVsRight: {
        id: 'medicalRecords.asymmetry.leftVsRight',
        defaultMessage: 'Esquerda {leftValue} vs Direita {rightValue}',
    },
    clinicalInterpretation: {
        id: 'medicalRecords.asymmetry.clinicalInterpretation',
        defaultMessage: 'Interpretação clínica',
    },
    recommendedConduct: {
        id: 'medicalRecords.asymmetry.recommendedConduct',
        defaultMessage: 'Conduta recomendada',
    },
    clinicalApplicability: {
        id: 'medicalRecords.asymmetry.clinicalApplicability',
        defaultMessage: 'Aplicabilidade Clínica',
    },
    clinicalApplicabilityText: {
        id: 'medicalRecords.asymmetry.clinicalApplicabilityText',
        defaultMessage: 'Normal ≤ 10 % ↔ dentro da variação fisiológica descrita por Boone & Soucie.\n11-20 % (Leve) ↔ acima do erro/MDC, mas ainda dentro da faixa que estudos recentes (Wang 2025) associam a ↑ risco porém moderado_.\n21-30 % (Moderada) ↔ aproxima‐se do ponto onde revisões (Parkinson 2021) apontam efeitos inconsistentes, exigindo intervenção clínica.\n{' > '} 30 % (Grave) ↔ superior aos limiares de força/ROM ligados a lesão (Cools 2014) – requer investigação estrutural completa.',
    },
    area: {
        id: 'medicalRecords.jointMobilityTable.area',
        defaultMessage: 'Área',
    },
    articulation: {
        id: 'medicalRecords.jointMobilityTable.articulation',
        defaultMessage: 'Articulação',
    },
    movement: {
        id: 'medicalRecords.jointMobilityTable.movement',
        defaultMessage: 'Movimento',
    },
    normal: {
        id: 'medicalRecords.jointMobilityTable.normal',
        defaultMessage: 'Normal',
    },
    rightSide: {
        id: 'medicalRecords.jointMobilityTable.rightSide',
        defaultMessage: 'LADO DIREITO',
    },
    leftSide: {
        id: 'medicalRecords.jointMobilityTable.leftSide',
        defaultMessage: 'LADO ESQUERDO',
    },
    unilateral: {
        id: 'medicalRecords.jointMobilityTable.unilateral',
        defaultMessage: 'UNILATERAL',
    },
    adm: {
        id: 'medicalRecords.jointMobilityTable.adm',
        defaultMessage: 'ADM',
    },
    nprs: {
        id: 'medicalRecords.jointMobilityTable.nprs',
        defaultMessage: 'NPRS',
    },
    painType: {
        id: 'medicalRecords.jointMobilityTable.painType',
        defaultMessage: 'Tipo Dor',
    },
    endFeel: {
        id: 'medicalRecords.jointMobilityTable.endFeel',
        defaultMessage: 'End-Feel',
    },
    deficiency: {
        id: 'medicalRecords.jointMobilityTable.deficiency',
        defaultMessage: 'Deficiência',
    },
    clinicalAnalysis: {
        id: 'medicalRecords.jointMobilityTable.clinicalAnalysis',
        defaultMessage: 'Assimetria',
    },
    clinicalObservations: {
        id: 'medicalRecords.jointMobilityTable.clinicalObservations',
        defaultMessage: 'Observações Clínicas',
    },
    compensations: {
        id: 'medicalRecords.jointMobilityTable.compensations',
        defaultMessage: 'Compensações:',
    },
    observations: {
        id: 'medicalRecords.jointMobilityTable.observations',
        defaultMessage: 'Observações:',
    },
    rightSideLabel: {
        id: 'medicalRecords.jointMobilityTable.rightSideLabel',
        defaultMessage: 'D:',
    },
    leftSideLabel: {
        id: 'medicalRecords.jointMobilityTable.leftSideLabel',
        defaultMessage: 'E:',
    },
    nprsQualifier: {
        id: 'medicalRecords.jointMobilityTable.nprsQualifier',
        defaultMessage: 'Qualificador de NPRS:',
    },
    deficiencyQualifier: {
        id: 'medicalRecords.jointMobilityTable.deficiencyQualifier',
        defaultMessage: 'Qualificador de Deficiência:',
    },
    asymmetry: {
        id: 'medicalRecords.jointMobilityTable.asymmetry',
        defaultMessage: 'Assimetria',
    },
    downloadPdf: {
        id: 'medicalRecords.downloadButton.downloadPdf',
        defaultMessage: 'Baixar PDF',
    },
    generatingPdf: {
        id: 'medicalRecords.downloadButton.generatingPdf',
        defaultMessage: 'Gerando PDF...',
    },
    pdfDownloadSuccess: {
        id: 'medicalRecords.downloadButton.pdfDownloadSuccess',
        defaultMessage: 'PDF baixado com sucesso!',
    },
    pdfGenerationError: {
        id: 'medicalRecords.downloadButton.pdfGenerationError',
        defaultMessage: 'Erro ao gerar o PDF. Tente novamente.',
    },
    exportReport: {
        id: 'medicalRecords.downloadButton.exportReport',
        defaultMessage: 'Exportar Relatório',
    },
    downloadPdfLarge: {
        id: 'medicalRecords.downloadButton.downloadPdfLarge',
        defaultMessage: 'Download PDF',
    },
    pdfExampleTitle: {
        id: 'medicalRecords.downloadButton.pdfExampleTitle',
        defaultMessage: 'Exemplo de Download PDF',
    },
    basicButton: {
        id: 'medicalRecords.downloadButton.basicButton',
        defaultMessage: 'Botão básico',
    },
    customTextButton: {
        id: 'medicalRecords.downloadButton.customTextButton',
        defaultMessage: 'Botão com texto customizado',
    },
    largeButton: {
        id: 'medicalRecords.downloadButton.largeButton',
        defaultMessage: 'Botão grande',
    },
    degree: {
        id: 'medicalRecords.table.degree',
        defaultMessage: 'Grau'
    },
    cif: {
        id: 'medicalRecords.table.cif',
        defaultMessage: 'CIF'
    },
    lsi: {
        id: 'medicalRecords.table.lsi',
        defaultMessage: 'LSI'
    },
    variation: {
        id: 'medicalRecords.table.variation',
        defaultMessage: 'Δ MMT'
    },
    painInterruption: {
        id: 'medicalRecords.table.painInterruption',
        defaultMessage: 'Interrompido por dor'
    },
    value1: {
        id: 'medicalRecords.movementTypeCard.value1',
        defaultMessage: 'Medida 1 (Kgf)'
    },
    value2: {
        id: 'medicalRecords.movementTypeCard.value2',
        defaultMessage: 'Medida 2 (Kgf)'
    },
    value3: {
        id: 'medicalRecords.movementTypeCard.value3',
        defaultMessage: 'Medida 3 (Kgf)'
    },
    leverArm: {
        id: 'medicalRecords.movementTypeCard.leverArm',
        defaultMessage: 'Braço de Alavanca (m)'
    },
    symmetricAssessment: {
        id: 'medicalRecords.symmetricAssessment',
        defaultMessage: 'Nenhuma(Avaliação Simétrica)'
    },
    injuredMember: {
        id: 'medicalRecords.injuredMember',
        defaultMessage: 'Membro Lesionado'
    },
    muscleBalanceAnalysisTitle: {
        id: 'medicalRecords.muscleBalanceAnalysisTitle',
        defaultMessage: 'Análise de Equilíbrio Muscular (Agonista/Antagonista)'
    },
    agonist: {
        id: 'medicalRecords.agonist',
        defaultMessage: 'Agonista:'
    },
    antagonist: {
        id: 'medicalRecords.antagonist',
        defaultMessage: 'Antagonista:'
    },
    ratio: {
        id: 'medicalRecords.ratio',
        defaultMessage: 'Razão:'
    },
    normal: {
        id: 'medicalRecords.normal',
        defaultMessage: 'Normal:'
    },
    kgf: {
        id: 'medicalRecords.kgf',
        defaultMessage: 'Kgf'
    },
    noItemsToDisplay: {
        id: 'medicalRecords.noItemsToDisplay',
        defaultMessage: 'Nenhum item para exibir'
    },
    imbalanceWeakAgonist: {
        id: 'medicalRecords.imbalanceWeakAgonist',
        defaultMessage: 'Desequilíbrio - Agonista Fraco'
    },
    imbalanceWeakAntagonist: {
        id: 'medicalRecords.imbalanceWeakAntagonist',
        defaultMessage: 'Desequilíbrio - Antagonista Fraco'
    },
    normalBalance: {
        id: 'medicalRecords.normalBalance',
        defaultMessage: 'Equilíbrio Normal'
    },
    highRiskAgonistInjury: {
        id: 'medicalRecords.highRiskAgonistInjury',
        defaultMessage: 'Alto risco de lesão do agonista'
    },
    highRiskAntagonistInjury: {
        id: 'medicalRecords.highRiskAntagonistInjury',
        defaultMessage: 'Alto risco de lesão do antagonista'
    },
    lowRiskInjury: {
        id: 'medicalRecords.lowRiskInjury',
        defaultMessage: 'Baixo risco de lesão'
    },
    strengthenAgonistGroup: {
        id: 'medicalRecords.strengthenAgonistGroup',
        defaultMessage: 'Fortalecer grupo agonista'
    },
    strengthenAntagonistGroup: {
        id: 'medicalRecords.strengthenAntagonistGroup',
        defaultMessage: 'Fortalecer grupo antagonista'
    },
    maintainProportion: {
        id: 'medicalRecords.maintainProportion',
        defaultMessage: 'Manter proporção'
    },
    muscleStrengthGrade: {
        id: 'medicalRecords.muscleStrengthGrade',
        defaultMessage: 'Grau de Força Muscular'
    },
    grade4Refinement: {
        id: 'medicalRecords.grade4Refinement',
        defaultMessage: 'Refinamento do Grau 4:'
    },
    minimalResistance: {
        id: 'medicalRecords.minimalResistance',
        defaultMessage: 'Resistência mínima'
    },
    moderateResistance: {
        id: 'medicalRecords.moderateResistance',
        defaultMessage: 'Resistência moderada'
    },
    goodResistance: {
        id: 'medicalRecords.goodResistance',
        defaultMessage: 'Resistência boa'
    },
    gradeValue: {
        id: 'medicalRecords.gradeValue',
        defaultMessage: 'Grau {value}'
    },
    oxfordDanielsScale: {
        id: 'medicalRecords.oxfordDanielsScale',
        defaultMessage: '📋 Escala Oxford/Daniels:'
    },
    grade01Description: {
        id: 'medicalRecords.grade01Description',
        defaultMessage: '0-1: Sem/mínima contração'
    },
    grade23Description: {
        id: 'medicalRecords.grade23Description',
        defaultMessage: '2-3: Movimento limitado'
    },
    grade44Description: {
        id: 'medicalRecords.grade44Description',
        defaultMessage: '4-,4,4+: Contra resistência'
    },
    grade5Description: {
        id: 'medicalRecords.grade5Description',
        defaultMessage: '5: Força normal'
    },
    testInterruptedByPain: {
        id: 'medicalRecords.testInterruptedByPain',
        defaultMessage: 'Teste interrompido por dor?'
    },
    testNotCompletedDueToPain: {
        id: 'medicalRecords.testNotCompletedDueToPain',
        defaultMessage: '⚠️ Teste não pôde ser completado devido à dor'
    },
    observations: {
        id: 'medicalRecords.observations',
        defaultMessage: 'Observações'
    },
    observationsPlaceholder: {
        id: 'medicalRecords.observationsPlaceholder',
        defaultMessage: 'Ex: Compensações, padrão alterado, dificuldade de ativação, capacidade de sustentação...'
    },
    zone: {
        id: 'medicalRecords.zone',
        defaultMessage: 'Zona'
    },
    loadKg: {
        id: 'medicalRecords.loadKg',
        defaultMessage: 'Carga (kg)'
    },
    setsRepetitions: {
        id: 'medicalRecords.setsRepetitions',
        defaultMessage: 'Séries × Repetições'
    },
    rest: {
        id: 'medicalRecords.rest',
        defaultMessage: 'Descanso'
    },
    rhythm: {
        id: 'medicalRecords.rhythm',
        defaultMessage: 'Ritmo'
    },
    reset: {
        id: 'medicalRecords.reset',
        defaultMessage: 'Reset:'
    },
    adjustForPatientHeight: {
        id: 'medicalRecords.adjustForPatientHeight',
        defaultMessage: 'Ajuste conforme altura do paciente, posicionamento ou equipamento'
    },
    analysisAutomaticCalculations: {
        id: 'medicalRecords.analysisAutomaticCalculations',
        defaultMessage: 'Análise - Cálculos Automáticos'
    },
    inconsistent: {
        id: 'medicalRecords.inconsistent',
        defaultMessage: 'Inconsistente'
    },
    isometricToDynamic: {
        id: 'medicalRecords.isometricToDynamic',
        defaultMessage: 'Isométrico → Dinâmico'
    },
    loadPrediction: {
        id: 'medicalRecords.loadPrediction',
        defaultMessage: 'Previsão de carga - {movementName}'
    },
    prediction1RM: {
        id: 'medicalRecords.prediction1RM',
        defaultMessage: 'Predição 1RM:'
    },
    asymmetryAnalysis: {
        id: 'medicalRecords.asymmetryAnalysis',
        defaultMessage: 'Análise de Assimetria'
    },
    lsiStandard: {
        id: 'medicalRecords.lsiStandard',
        defaultMessage: 'LSI Padrão'
    },
    lsiClinical: {
        id: 'medicalRecords.lsiClinical',
        defaultMessage: 'LSI Clínico'
    },
    smallerLarger: {
        id: 'medicalRecords.smallerLarger',
        defaultMessage: 'Menor/Maior'
    },
    leftStrength: {
        id: 'medicalRecords.leftStrength',
        defaultMessage: 'Força Esq.'
    },
    rightStrength: {
        id: 'medicalRecords.rightStrength',
        defaultMessage: 'Força Dir.'
    },
    severeAsymmetry: {
        id: 'medicalRecords.severeAsymmetry',
        defaultMessage: 'Assimetria Severa:'
    },
    urgentIntervention: {
        id: 'medicalRecords.urgentIntervention',
        defaultMessage: 'Intervenção urgente'
    },
    deltaMmt: {
        id: 'medicalRecords.deltaMmt',
        defaultMessage: 'Δ MMT:'
    },
    repetitions: {
        id: 'medicalRecords.repetitions',
        defaultMessage: 'Repetições'
    },
    sets: {
        id: 'medicalRecords.sets',
        defaultMessage: 'Séries'
    },
    asymmetryDataNotAvailable: {
        id: 'medicalRecords.asymmetryDataNotAvailable',
        defaultMessage: 'Não há dados de assimetria disponíveis'
    },
    isometricStrengthMeasurements: {
        id: 'medicalRecords.isometricStrengthMeasurements',
        defaultMessage: 'Medições de Força Isométrica'
    },
    agonistAntagonistMuscleRelations: {
        id: 'medicalRecords.agonistAntagonistMuscleRelations',
        defaultMessage: 'Relações Musculares Agonista/Antagonista'
    },
    trainingLoadPrescription: {
        id: 'medicalRecords.trainingLoadPrescription',
        defaultMessage: 'Prescrição de Cargas de Treinamento'
    },
    trainingZonesBasedOn1RM: {
        id: 'medicalRecords.trainingZonesBasedOn1RM',
        defaultMessage: 'Zonas de Treinamento Baseadas em 1RM Predito'
    },
    oneRMCalculationFormula: {
        id: 'medicalRecords.oneRMCalculationFormula',
        defaultMessage: 'Cálculo: 1RM = 0.714 + (0.783 × MFI)'
    },
    mfiKgf: {
        id: 'medicalRecords.mfiKgf',
        defaultMessage: 'MFI (kgf)'
    },
    oneRMPredicted: {
        id: 'medicalRecords.oneRMPredicted',
        defaultMessage: '1RM Predito'
    },
    oneRMPredictedValue: {
        id: 'medicalRecords.oneRMPredictedValue',
        defaultMessage: '1RM Predito: {value} kg'
    },
    movement: {
        id: 'medicalRecords.movement',
        defaultMessage: 'Movimento'
    },
    rightSide: {
        id: 'medicalRecords.rightSide',
        defaultMessage: 'Direito'
    },
    leftSide: {
        id: 'medicalRecords.leftSide',
        defaultMessage: 'Esquerdo'
    },
    unilateralSide: {
        id: 'medicalRecords.unilateralSide',
        defaultMessage: 'Unilateral'
    },
    articulation: {
        id: 'medicalRecords.articulation',
        defaultMessage: 'Articulação'
    },
    measurementsAndAnalysis: {
        id: 'medicalRecords.measurementsAndAnalysis',
        defaultMessage: 'MEDIÇÕES E ANÁLISE'
    },
    leftSideUpper: {
        id: 'medicalRecords.leftSideUpper',
        defaultMessage: 'LADO ESQUERDO'
    },
    rightSideUpper: {
        id: 'medicalRecords.rightSideUpper',
        defaultMessage: 'LADO DIREITO'
    },
    oneRMKg: {
        id: 'medicalRecords.oneRMKg',
        defaultMessage: '1RM (kg)'
    },
    analysis: {
        id: 'medicalRecords.analysis',
        defaultMessage: 'ANÁLISE'
    },
    lsiPercent: {
        id: 'medicalRecords.lsiPercent',
        defaultMessage: 'LSI (%)'
    },
    lsiClinicalShort: {
        id: 'medicalRecords.lsiClinicalShort',
        defaultMessage: 'LSI Clínico'
    },
    asymmetryShort: {
        id: 'medicalRecords.asymmetryShort',
        defaultMessage: 'Assim. (%)'
    },
    relations: {
        id: 'medicalRecords.relations',
        defaultMessage: 'Relações'
    },
    agonistAntagonistLeft: {
        id: 'medicalRecords.agonistAntagonistLeft',
        defaultMessage: 'Ag/Ant E(%)'
    },
    agonistAntagonistRight: {
        id: 'medicalRecords.agonistAntagonistRight',
        defaultMessage: 'Ag/Ant D(%)'
    },
    agonistAntagonistPercent: {
        id: 'medicalRecords.agonistAntagonistPercent',
        defaultMessage: 'Ag/Ant (%)'
    },
    trainingLoadsKg: {
        id: 'medicalRecords.trainingLoadsKg',
        defaultMessage: 'CARGAS DE TREINAMENTO (kg)'
    },
    enduranceShort: {
        id: 'medicalRecords.enduranceShort',
        defaultMessage: 'Resist'
    },
    hypertrophyShort: {
        id: 'medicalRecords.hypertrophyShort',
        defaultMessage: 'Hipert'
    },
    strengthShort: {
        id: 'medicalRecords.strengthShort',
        defaultMessage: 'Força'
    },
    powerShort: {
        id: 'medicalRecords.powerShort',
        defaultMessage: 'Potên'
    },
    speedShort: {
        id: 'medicalRecords.speedShort',
        defaultMessage: 'Veloc'
    },
    lsiDynamometry: {
        id: 'medicalRecords.lsiDynamometry',
        defaultMessage: 'LSI Dinamometria:'
    },
    inactivate: {
        id: 'medicalRecords.inactivate',
        defaultMessage: 'Inativar'
    },
    activate: {
        id: 'medicalRecords.activate',
        defaultMessage: 'Ativar'
    },
    showInactiveFields: {
        id: 'medicalRecords.showInactiveFields',
        defaultMessage: 'Mostrar campos inativos'
    },
    hideInactiveFields: {
        id: 'medicalRecords.hideInactiveFields',
        defaultMessage: 'Ocultar campos inativos'
    },
    confirm: {
        id: 'medicalRecords.confirm',
        defaultMessage: 'Confirmar'
    },
    confirmToggleStatusMessage: {
        id: 'medicalRecords.confirmToggleStatusMessage',
        defaultMessage: 'Tem certeza que deseja {action} este {type}?'
    },
    confirmToggleStatusInactivate: {
        id: 'medicalRecords.confirmToggleStatusInactivate',
        defaultMessage: 'inativar'
    },
    confirmToggleStatusActivate: {
        id: 'medicalRecords.confirmToggleStatusActivate',
        defaultMessage: 'ativar'
    },
    yes: {
        id: 'medicalRecords.yes',
        defaultMessage: 'Sim'
    },
    cancel: {
        id: 'medicalRecords.cancel',
        defaultMessage: 'Cancelar'
    },
    showInactiveForms: {
        id: 'medicalRecords.showInactiveForms',
        defaultMessage: 'Mostrar formulários inativos'
    },
    hideInactiveForms: {
        id: 'medicalRecords.hideInactiveForms',
        defaultMessage: 'Ocultar formulários inativos'
    },
    showInactiveDrafts: {
        id: 'medicalRecords.showInactiveDrafts',
        defaultMessage: 'Mostrar rascunhos inativos'
    },
    hideInactiveDrafts: {
        id: 'medicalRecords.hideInactiveDrafts',
        defaultMessage: 'Ocultar rascunhos inativos'
    },
    form: {
        id: 'medicalRecords.form',
        defaultMessage: 'formulário'
    },
    draft: {
        id: 'medicalRecords.draft',
        defaultMessage: 'rascunho'
    },
    preCustomerRegistrationDeleteTitle: {
        id: 'medicalRecords.preCustomerRegistrationDeleteTitle',
        defaultMessage: 'Confirmar exclusão'
    },
    preCustomerRegistrationDeleteContent: {
        id: 'medicalRecords.preCustomerRegistrationDeleteContent',
        defaultMessage: 'Tem certeza que deseja excluir este link de pré-cadastro? Esta ação é irreversível.'
    },
    deleteConfirm: {
        id: 'medicalRecords.deleteConfirm',
        defaultMessage: 'Sim, excluir'
    },
    validationFailed: {
        id: 'medicalRecords.validationFailed',
        defaultMessage: 'Erro de validação nos campos do formulário'
    },
    preCustomerName: {
        id: 'medicalRecords.preCustomerName',
        defaultMessage: 'Nome do Pré-cadastro'
    },
    nameRequired: {
        id: 'medicalRecords.nameRequired',
        defaultMessage: 'Nome é obrigatório'
    },
    nameMinLength: {
        id: 'medicalRecords.nameMinLength',
        defaultMessage: 'Nome deve ter pelo menos 2 caracteres'
    },
    namePlaceholder: {
        id: 'medicalRecords.namePlaceholder',
        defaultMessage: 'Digite o nome para identificar este link'
    },
    workspace: {
        id: 'medicalRecords.workspace',
        defaultMessage: 'Workspace'
    },
    workspaceRequired: {
        id: 'medicalRecords.workspaceRequired',
        defaultMessage: 'Workspace é obrigatório'
    },
    workspacePlaceholder: {
        id: 'medicalRecords.workspacePlaceholder',
        defaultMessage: 'Selecione o workspace'
    },
    expirationDateTime: {
        id: 'medicalRecords.expirationDateTime',
        defaultMessage: 'Data e Hora de Expiração'
    },
    expirationRequired: {
        id: 'medicalRecords.expirationRequired',
        defaultMessage: 'Data de expiração é obrigatória'
    },
    expirationPlaceholder: {
        id: 'medicalRecords.expirationPlaceholder',
        defaultMessage: 'Selecione quando o link expira'
    },
    generatedLink: {
        id: 'medicalRecords.generatedLink',
        defaultMessage: 'Link Gerado'
    },
    expiresOn: {
        id: 'medicalRecords.expiresOn',
        defaultMessage: 'Expira em: {date}'
    },
    expired: {
        id: 'medicalRecords.expired',
        defaultMessage: '(Expirado)'
    },
    tooltipShareWhatsApp: {
        id: 'medicalRecords.tooltipShareWhatsApp',
        defaultMessage: 'Compartilhar no WhatsApp'
    },
    howItWorks: {
        id: 'medicalRecords.howItWorks',
        defaultMessage: 'Como funciona:'
    },
    howItWorksStep1: {
        id: 'medicalRecords.howItWorksStep1',
        defaultMessage: '• Envie este link para o cliente'
    },
    howItWorksStep2: {
        id: 'medicalRecords.howItWorksStep2',
        defaultMessage: '• O cliente preencherá seus dados através do link'
    },
    howItWorksStep3: {
        id: 'medicalRecords.howItWorksStep3',
        defaultMessage: '• Você receberá os dados do pré-cadastro automaticamente'
    },
    howItWorksStep4: {
        id: 'medicalRecords.howItWorksStep4',
        defaultMessage: '• O link expira na data/hora definida acima'
    },
    selectFormForPreRegistration: {
        id: 'medicalRecords.selectFormForPreRegistration',
        defaultMessage: 'Selecione o formulário para o pré-cadastro'
    },
    tableHeaderName: {
        id: 'medicalRecords.tableHeaderName',
        defaultMessage: 'Nome'
    },
    tableHeaderGeneratedLink: {
        id: 'medicalRecords.tableHeaderGeneratedLink',
        defaultMessage: 'Link Gerado'
    },
    tableHeaderExpirationDate: {
        id: 'medicalRecords.tableHeaderExpirationDate',
        defaultMessage: 'Data de Expiração'
    },
    tableHeaderStatus: {
        id: 'medicalRecords.tableHeaderStatus',
        defaultMessage: 'Status'
    },
    tableHeaderCreatedAt: {
        id: 'medicalRecords.tableHeaderCreatedAt',
        defaultMessage: 'Criado em'
    },
    statusActive: {
        id: 'medicalRecords.statusActive',
        defaultMessage: 'Ativo'
    },
    statusExpired: {
        id: 'medicalRecords.statusExpired',
        defaultMessage: 'Expirado'
    },
    tooltipCopyLink: {
        id: 'medicalRecords.tooltipCopyLink',
        defaultMessage: 'Copiar link'
    },
    tooltipOpenLink: {
        id: 'medicalRecords.tooltipOpenLink',
        defaultMessage: 'Abrir link'
    },
    paginationShowTotal: {
        id: 'medicalRecords.paginationShowTotal',
        defaultMessage: '{start}-{end} de {total} itens'
    },
    registrationSuccessTitle: {
        id: 'medicalRecords.registrationSuccessTitle',
        defaultMessage: 'Cadastro concluído com sucesso!'
    },
    registrationSuccessSubtitle: {
        id: 'medicalRecords.registrationSuccessSubtitle',
        defaultMessage: 'Seus dados foram enviados.'
    },
    registrationSuccessSubtitleWithName: {
        id: 'medicalRecords.registrationSuccessSubtitleWithName',
        defaultMessage: 'Obrigado, {name}. Seus dados foram enviados.'
    },
    startForm: {
        id: 'medicalRecords.startForm',
        defaultMessage: 'Iniciar formulário'
    },
    invalidOrExpiredLink: {
        id: 'medicalRecords.invalidOrExpiredLink',
        defaultMessage: 'Link inválido ou expirado.'
    },
    doNotLeavePageUntilComplete: {
        id: 'medicalRecords.doNotLeavePageUntilComplete',
        defaultMessage: 'Não saia desta página até concluir'
    },
    loadingPreRegistrationData: {
        id: 'medicalRecords.loadingPreRegistrationData',
        defaultMessage: 'Carregando dados do pré-cadastro...'
    },
    savingYourData: {
        id: 'medicalRecords.savingYourData',
        defaultMessage: 'Estamos salvando seus dados, aguarde um instante...'
    },
    clientPreRegistration: {
        id: 'medicalRecords.clientPreRegistration',
        defaultMessage: 'Pré-cadastro de Cliente'
    },
    fillDataToComplete: {
        id: 'medicalRecords.fillDataToComplete',
        defaultMessage: 'Preencha seus dados para finalizar seu cadastro'
    },
    generalData: {
        id: 'medicalRecords.generalData',
        defaultMessage: 'Dados gerais'
    },
    address: {
        id: 'medicalRecords.address',
        defaultMessage: 'Endereço'
    },
    preRegistrationUnavailableOrExpired: {
        id: 'medicalRecords.preRegistrationUnavailableOrExpired',
        defaultMessage: 'Pré-cadastro indisponível ou expirado'
    },
    preRegistrationLinkInvalidDescription: {
        id: 'medicalRecords.preRegistrationLinkInvalidDescription',
        defaultMessage: 'O link de pré-cadastro informado está inválido ou expirou. Por favor, verifique com o administrador para obter um novo acesso.'
    },
    preRegistrationOutdatedLink: {
        id: 'medicalRecords.preRegistrationOutdatedLink',
        defaultMessage: 'Link de pré-cadastro desatualizado'
    },
    preRegistrationOutdatedLinkDescription: {
        id: 'medicalRecords.preRegistrationOutdatedLinkDescription',
        defaultMessage: 'Este link de pré-cadastro está desatualizado. Verifique com o criador ou administrador do link para que ele possa atualizar o acesso.'
    },
    muscleStrengthProfessionalAssessmentManual: {
        id: 'medicalRecords.muscleStrength.professionalAssessment',
        defaultMessage: 'Avaliação profissional de força muscular manual com identificação de assimetrias e geração de relatório'
    },
    muscleStrengthProfessionalAssessmentDynamometry: {
        id: 'medicalRecords.muscleStrength.professionalAssessmentDynamometry',
        defaultMessage: 'Avaliação profissional de força muscular por dinamometria isométrica com identificação de assimetrias e geração de relatório'
    },
    balanceClassificationAgonistAntagonist: {
        id: 'medicalRecords.balanceClassificationAgonistAntagonist',
        defaultMessage: 'Classificação agonista/antagonista'
    },
    socialBond: {
        id: 'medicalRecords.socialBond',
        defaultMessage: 'Responsável Legal'
    },
    selectFieldsForIndicators: {
        id: 'medicalRecords.selectFieldsForIndicators',
        defaultMessage: 'Selecionar Campos para Indicadores'
    },
    uploadForm: {
        id: 'medicalRecords.uploadForm',
        defaultMessage: 'Upload de Formulário'
    },
    uploadFormDocumentUpload: {
        id: 'medicalRecords.uploadForm.documentUpload',
        defaultMessage: 'Upload de documento'
    },
    uploadFormSendingToServer: {
        id: 'medicalRecords.uploadForm.sendingToServer',
        defaultMessage: 'Enviando arquivo para o servidor...'
    },
    uploadFormDocumentSent: {
        id: 'medicalRecords.uploadForm.documentSent',
        defaultMessage: 'Documento enviado com sucesso para o servidor'
    },
    uploadFormSendingDocument: {
        id: 'medicalRecords.uploadForm.sendingDocument',
        defaultMessage: 'Enviando documento para o servidor...'
    },
    uploadFormErrorProcessing: {
        id: 'medicalRecords.uploadForm.errorProcessing',
        defaultMessage: 'Erro no processamento'
    },
    uploadFormErrorOccurred: {
        id: 'medicalRecords.uploadForm.errorOccurred',
        defaultMessage: 'Ocorreu um erro durante o processamento'
    },
    uploadFormProcessingComplete: {
        id: 'medicalRecords.uploadForm.processingComplete',
        defaultMessage: 'Processamento concluído'
    },
    uploadFormFormExtracted: {
        id: 'medicalRecords.uploadForm.formExtracted',
        defaultMessage: 'Formulário extraído e mapeado com sucesso'
    },
    uploadFormProcessing: {
        id: 'medicalRecords.uploadForm.processing',
        defaultMessage: 'Processando'
    },
    uploadFormStepUploading: {
        id: 'medicalRecords.uploadForm.step.uploading',
        defaultMessage: 'Enviando documento para o servidor...'
    },
    uploadFormStepAnalyzing: {
        id: 'medicalRecords.uploadForm.step.analyzing',
        defaultMessage: 'Analisando estrutura do documento...'
    },
    uploadFormStepExtracting: {
        id: 'medicalRecords.uploadForm.step.extracting',
        defaultMessage: 'Extraindo informações do formulário...'
    },
    uploadFormStepValidating: {
        id: 'medicalRecords.uploadForm.step.validating',
        defaultMessage: 'Validando campos extraídos...'
    },
    uploadFormStepMapping: {
        id: 'medicalRecords.uploadForm.step.mapping',
        defaultMessage: 'Mapeando dados para o formato interno...'
    },
    uploadFormStepFinalizing: {
        id: 'medicalRecords.uploadForm.step.finalizing',
        defaultMessage: 'Finalizando processamento...'
    },
    uploadFormTaskUpload: {
        id: 'medicalRecords.uploadForm.task.upload',
        defaultMessage: '📤 Upload do documento'
    },
    uploadFormTaskAnalysis: {
        id: 'medicalRecords.uploadForm.task.analysis',
        defaultMessage: '🔍 Análise da estrutura'
    },
    uploadFormTaskAnalysisDetails: {
        id: 'medicalRecords.uploadForm.task.analysisDetails',
        defaultMessage: 'Analisando a estrutura do documento e identificando campos...'
    },
    uploadFormTaskExtraction: {
        id: 'medicalRecords.uploadForm.task.extraction',
        defaultMessage: '📝 Extração de dados'
    },
    uploadFormTaskExtractionDetails: {
        id: 'medicalRecords.uploadForm.task.extractionDetails',
        defaultMessage: 'Extraindo informações e dados dos campos identificados...'
    },
    uploadFormTaskValidation: {
        id: 'medicalRecords.uploadForm.task.validation',
        defaultMessage: '✓ Validação'
    },
    uploadFormTaskValidationDetails: {
        id: 'medicalRecords.uploadForm.task.validationDetails',
        defaultMessage: 'Validando os dados extraídos e verificando consistência...'
    },
    uploadFormTaskMapping: {
        id: 'medicalRecords.uploadForm.task.mapping',
        defaultMessage: '🗺️ Mapeamento'
    },
    uploadFormTaskMappingDetails: {
        id: 'medicalRecords.uploadForm.task.mappingDetails',
        defaultMessage: 'Mapeando campos extraídos para o formato do sistema...'
    },
    uploadFormTaskFinalizing: {
        id: 'medicalRecords.uploadForm.task.finalizing',
        defaultMessage: '🎯 Finalização'
    },
    uploadFormTaskFinalizingDetails: {
        id: 'medicalRecords.uploadForm.task.finalizingDetails',
        defaultMessage: 'Finalizando o processamento e preparando o resultado...'
    },
    uploadFormTaskCompleted: {
        id: 'medicalRecords.uploadForm.task.completed',
        defaultMessage: '✅ Processamento concluído'
    },
    uploadFormTaskCompletedDetails: {
        id: 'medicalRecords.uploadForm.task.completedDetails',
        defaultMessage: 'Formulário extraído e mapeado com sucesso! Pronto para revisão.'
    },
    uploadFormTaskError: {
        id: 'medicalRecords.uploadForm.task.error',
        defaultMessage: '❌ Erro no processamento'
    },
    uploadFormTaskErrorDetails: {
        id: 'medicalRecords.uploadForm.task.errorDetails',
        defaultMessage: 'Ocorreu um erro durante o processamento do documento.'
    },
    uploadFormErrorUnknown: {
        id: 'medicalRecords.uploadForm.errorUnknown',
        defaultMessage: 'Erro desconhecido'
    },
    uploadFormPipelineTitle: {
        id: 'medicalRecords.uploadForm.pipelineTitle',
        defaultMessage: 'Pipeline de Processamento'
    },
    uploadFormSending: {
        id: 'medicalRecords.uploadForm.sending',
        defaultMessage: 'Enviando...'
    },
    uploadFormSendFiles: {
        id: 'medicalRecords.uploadForm.sendFiles',
        defaultMessage: 'Enviar {count} arquivo'
    },
    uploadFormSendFilesPlural: {
        id: 'medicalRecords.uploadForm.sendFilesPlural',
        defaultMessage: 'Enviar {count} arquivos'
    },
    chatIA: {
        id: 'medicalRecords.chatIA',
        defaultMessage: 'Chat IA'
    },
    chatIANewSession: {
        id: 'medicalRecords.chatIA.newSession',
        defaultMessage: 'Nova Sessão'
    },
    chatIAFormName: {
        id: 'medicalRecords.chatIA.formName',
        defaultMessage: 'Nome do Formulário'
    },
    chatIAInitialMessage: {
        id: 'medicalRecords.chatIA.initialMessage',
        defaultMessage: 'Mensagem Inicial (Opcional)'
    },
    chatIAStart: {
        id: 'medicalRecords.chatIA.start',
        defaultMessage: 'Iniciar'
    },
    chatIATypeMessage: {
        id: 'medicalRecords.chatIA.typeMessage',
        defaultMessage: 'Digite sua mensagem...'
    },
    chatIASend: {
        id: 'medicalRecords.chatIA.send',
        defaultMessage: 'Enviar'
    },
    chatIATyping: {
        id: 'medicalRecords.chatIA.typing',
        defaultMessage: 'Digitando...'
    },
    chatIAGeneratingFields: {
        id: 'medicalRecords.chatIA.generatingFields',
        defaultMessage: 'Gerando campos'
    },
    chatIAFinish: {
        id: 'medicalRecords.chatIA.finish',
        defaultMessage: 'Finalizar Formulário'
    },
    chatIAResume: {
        id: 'medicalRecords.chatIA.resume',
        defaultMessage: 'Sessões Anteriores'
    },
    chatIAPreview: {
        id: 'medicalRecords.chatIA.preview',
        defaultMessage: 'Preview do Formulário'
    },
    chatIAStats: {
        id: 'medicalRecords.chatIA.stats',
        defaultMessage: 'Estatísticas'
    },
    chatIATotalFields: {
        id: 'medicalRecords.chatIA.totalFields',
        defaultMessage: 'Total de Campos'
    },
    chatIATotalMessages: {
        id: 'medicalRecords.chatIA.totalMessages',
        defaultMessage: 'Total de Mensagens'
    },
    chatIADownloadJSON: {
        id: 'medicalRecords.chatIA.downloadJSON',
        defaultMessage: 'Baixar JSON'
    },
    chatIAConfirmFinish: {
        id: 'medicalRecords.chatIA.confirmFinish',
        defaultMessage: 'Deseja finalizar e salvar o formulário?'
    },
    chatIASessionFinished: {
        id: 'medicalRecords.chatIA.sessionFinished',
        defaultMessage: 'Sessão finalizada com sucesso!'
    },
    chatIAError: {
        id: 'medicalRecords.chatIA.error',
        defaultMessage: 'Erro ao processar mensagem'
    },
    chatIAFormNameRequired: {
        id: 'medicalRecords.chatIA.formNameRequired',
        defaultMessage: 'Nome do formulário é obrigatório'
    },
    chatIANoSessions: {
        id: 'medicalRecords.chatIA.noSessions',
        defaultMessage: 'Nenhuma sessão ativa encontrada'
    },
    chatIAResumeSession: {
        id: 'medicalRecords.chatIA.resumeSession',
        defaultMessage: 'Retomar'
    },
    chatIACancel: {
        id: 'medicalRecords.chatIA.cancel',
        defaultMessage: 'Cancelar'
    },
    chatIAClose: {
        id: 'medicalRecords.chatIA.close',
        defaultMessage: 'Fechar'
    },
    chatIANoMessages: {
        id: 'medicalRecords.chatIA.noMessages',
        defaultMessage: 'Nenhuma mensagem ainda. Comece uma conversa!'
    },
    chatIAWelcome: {
        id: 'medicalRecords.chatIA.welcome',
        defaultMessage: 'Olá! Estou aqui para ajudá-lo a criar um formulário. Como posso ajudar?'
    },
    chatIAFieldsInForm: {
        id: 'medicalRecords.chatIA.fieldsInForm',
        defaultMessage: '{count, plural, =0 {Nenhum campo} one {# campo} other {# campos}}'
    },
    chatIAConfirm: {
        id: 'medicalRecords.chatIA.confirm',
        defaultMessage: 'Confirmar'
    },
    chatIAConfirmTitle: {
        id: 'medicalRecords.chatIA.confirmTitle',
        defaultMessage: 'Confirmar alterações?'
    },
    chatIAConfirmMessage: {
        id: 'medicalRecords.chatIA.confirmMessage',
        defaultMessage: 'Ao confirmar, os campos serão salvos no banco de dados e o chat será encerrado. Deseja continuar?'
    },
    chatIAInsufficientTokensTitle: {
        id: 'medicalRecords.chatIA.insufficientTokensTitle',
        defaultMessage: 'Tokens Insuficientes'
    },
    chatIAInsufficientTokensMessage: {
        id: 'medicalRecords.chatIA.insufficientTokensMessage',
        defaultMessage: 'Não há tokens disponíveis suficientes para processar esta solicitação.'
    },
    chatIAInsufficientTokensContact: {
        id: 'medicalRecords.chatIA.insufficientTokensContact',
        defaultMessage: 'Por favor, entre em contato com o administrador do sistema para adquirir mais tokens.'
    },
    chatIATokensAvailable: {
        id: 'medicalRecords.chatIA.tokensAvailable',
        defaultMessage: 'Tokens disponíveis'
    },
    chatIATokensRequired: {
        id: 'medicalRecords.chatIA.tokensRequired',
        defaultMessage: 'Tokens necessários'
    },
    chatIAHeroTitle: {
        id: 'medicalRecords.chatIA.heroTitle',
        defaultMessage: 'Descreva o formulário que você quer criar ou ajustar'
    },
    chatIACancelChangesMessage: {
        id: 'medicalRecords.chatIA.cancelChangesMessage',
        defaultMessage: 'Deseja cancelar as alterações? O formulário será restaurado ao estado anterior.'
    },
    chatIASuggestionCreateInitialForm: {
        id: 'medicalRecords.chatIA.suggestion.createInitialForm',
        defaultMessage: 'Criar um formulário de avaliação inicial'
    },
    chatIASuggestionCreateInitialFormPrompt: {
        id: 'medicalRecords.chatIA.suggestion.createInitialFormPrompt',
        defaultMessage: 'Crie um formulário de avaliação inicial com campos essenciais.'
    },
    chatIASuggestionAddClinicalEvolution: {
        id: 'medicalRecords.chatIA.suggestion.addClinicalEvolution',
        defaultMessage: 'Adicionar campos de evolução clínica'
    },
    chatIASuggestionAddClinicalEvolutionPrompt: {
        id: 'medicalRecords.chatIA.suggestion.addClinicalEvolutionPrompt',
        defaultMessage: 'Adicione campos para registrar evolução clínica e observações.'
    },
    chatIASuggestionImproveFormOrganization: {
        id: 'medicalRecords.chatIA.suggestion.improveFormOrganization',
        defaultMessage: 'Melhorar a organização do formulário'
    },
    chatIASuggestionImproveFormOrganizationPrompt: {
        id: 'medicalRecords.chatIA.suggestion.improveFormOrganizationPrompt',
        defaultMessage: 'Revise a organização do formulário atual e sugira melhorias.'
    },
    uploadComponentDragFiles: {
        id: 'medicalRecords.uploadComponent.dragFiles',
        defaultMessage: 'Arraste arquivos PDF ou DOCX aqui'
    },
    uploadComponentClickToSelect: {
        id: 'medicalRecords.uploadComponent.clickToSelect',
        defaultMessage: 'ou clique para selecionar'
    },
    uploadComponentMaxFileSize: {
        id: 'medicalRecords.uploadComponent.maxFileSize',
        defaultMessage: 'Máximo 10MB por arquivo'
    },
    uploadComponentReadyToSend: {
        id: 'medicalRecords.uploadComponent.readyToSend',
        defaultMessage: 'Pronto para envio'
    },
    uploadComponentProcessing: {
        id: 'medicalRecords.uploadComponent.processing',
        defaultMessage: 'Processando...'
    },
    uploadComponentCompleted: {
        id: 'medicalRecords.uploadComponent.completed',
        defaultMessage: 'Concluído'
    },
    uploadComponentErrorProcessing: {
        id: 'medicalRecords.uploadComponent.errorProcessing',
        defaultMessage: 'Erro no processamento'
    },
    taskItemProgress: {
        id: 'medicalRecords.taskItem.progress',
        defaultMessage: 'Progresso'
    },
    taskItemFieldsDetected: {
        id: 'medicalRecords.taskItem.fieldsDetected',
        defaultMessage: 'Campos detectados:'
    },
    taskItemProblemsFound: {
        id: 'medicalRecords.taskItem.problemsFound',
        defaultMessage: 'Problemas encontrados:'
    },
    taskItemProcessingLogs: {
        id: 'medicalRecords.taskItem.processingLogs',
        defaultMessage: 'Logs do processamento:'
    },
    taskItemMoreLogs: {
        id: 'medicalRecords.taskItem.moreLogs',
        defaultMessage: '... e mais {count} logs'
    },
    managerTypeInputLoading: {
        id: 'medicalRecords.managerTypeInput.loading',
        defaultMessage: 'Carregando...'
    },
    managerTypeInputSimilar: {
        id: 'medicalRecords.managerTypeInput.similar',
        defaultMessage: 'similar'
    },
    managerTypeInputSimilarFieldFound: {
        id: 'medicalRecords.managerTypeInput.similarFieldFound',
        defaultMessage: 'Campo similar encontrado:'
    },
    managerTypeInputExistingField: {
        id: 'medicalRecords.managerTypeInput.existingField',
        defaultMessage: 'campo existente'
    },
    managerTypeInputCompareFields: {
        id: 'medicalRecords.managerTypeInput.compareFields',
        defaultMessage: 'Comparar campos'
    },
    comparisonModalUseExistingField: {
        id: 'medicalRecords.comparisonModal.useExistingField',
        defaultMessage: 'Usar campo existente'
    },
    comparisonModalKeepNewField: {
        id: 'medicalRecords.comparisonModal.keepNewField',
        defaultMessage: 'Manter novo campo'
    },
    comparisonModalSimilarity: {
        id: 'medicalRecords.comparisonModal.similarity',
        defaultMessage: 'de similaridade'
    },
    comparisonModalSimilarFieldsFound: {
        id: 'medicalRecords.comparisonModal.similarFieldsFound',
        defaultMessage: 'Campos similares encontrados'
    },
    comparisonModalDescription: {
        id: 'medicalRecords.comparisonModal.description',
        defaultMessage: 'Encontramos um campo existente com características semelhantes. Compare e escolha qual deseja usar:'
    },
    comparisonModalNewField: {
        id: 'medicalRecords.comparisonModal.newField',
        defaultMessage: 'NOVO CAMPO'
    },
    comparisonModalExistingField: {
        id: 'medicalRecords.comparisonModal.existingField',
        defaultMessage: 'CAMPO EXISTENTE'
    },
    transcriptionObservationsTitle: {
        id: 'usecore.answer.builder.transcriptionObservationsTitle',
        defaultMessage: 'Observações da Transcrição'
    },
    transcriptionUnavailable: {
        id: 'usecore.transcription.button.unavailable',
        defaultMessage: 'Transcrição indisponível'
    },
    transcriptionSmart: {
        id: 'usecore.transcription.button.smart',
        defaultMessage: 'Transcrição inteligente com IA'
    },
    transcriptionLabel: {
        id: 'usecore.transcription.button.label',
        defaultMessage: 'Narrar Atendimento'
    },
    transcriptionTemplateModalTitle: {
        id: 'usecore.transcription.template.modalTitle',
        defaultMessage: 'Selecionar Template de Formatação'
    },
    transcriptionTemplateSearchPlaceholder: {
        id: 'usecore.transcription.template.searchPlaceholder',
        defaultMessage: 'Buscar template...'
    },
    transcriptionTemplateNotFoundSearch: {
        id: 'usecore.transcription.template.notFoundSearch',
        defaultMessage: 'Nenhum template encontrado'
    },
    transcriptionTemplateNotFound: {
        id: 'usecore.transcription.template.notFound',
        defaultMessage: 'Nenhum template de Modo Livre disponível'
    },
    transcriptionTemplateCreateInstruction: {
        id: 'usecore.transcription.template.createInstruction',
        defaultMessage: 'Crie um template do tipo "Modo Livre" em Templates'
    },
    transcriptionTemplateNoDescription: {
        id: 'usecore.transcription.template.noDescription',
        defaultMessage: 'Sem descrição'
    },
    transcriptionStepTranscription: {
        id: 'usecore.transcription.step.transcription',
        defaultMessage: 'Transcrição'
    },
    transcriptionStepDescription: {
        id: 'usecore.transcription.step.description',
        defaultMessage: 'Grave ou digite a descrição'
    },
    transcriptionStepReview: {
        id: 'usecore.transcription.step.review',
        defaultMessage: 'Revisão'
    },
    transcriptionStepReviewDescription: {
        id: 'usecore.transcription.step.reviewDescription',
        defaultMessage: 'Revise e edite o texto'
    },
    transcriptionStepFields: {
        id: 'usecore.transcription.step.fields',
        defaultMessage: 'Campos'
    },
    transcriptionStepFieldsDescription: {
        id: 'usecore.transcription.step.fieldsDescription',
        defaultMessage: 'Confirme os valores'
    },
    transcriptionStepResult: {
        id: 'usecore.transcription.step.result',
        defaultMessage: 'Resultado'
    },
    transcriptionStepResultDescription: {
        id: 'usecore.transcription.step.resultDescription',
        defaultMessage: 'Texto corrigido'
    },
    transcriptionBrowserNotSupported: {
        id: 'usecore.transcription.browserNotSupported',
        defaultMessage: 'Seu navegador não suporta captura de áudio.'
    },
    transcriptionStopAndTranscribe: {
        id: 'usecore.transcription.stopAndTranscribe',
        defaultMessage: 'Parar e Transcrever'
    },
    transcriptionStartRecording: {
        id: 'usecore.transcription.startRecording',
        defaultMessage: 'Iniciar gravação'
    },
    transcriptionProcessing: {
        id: 'usecore.transcription.processing',
        defaultMessage: 'PROCESSANDO...'
    },
    transcriptionStop: {
        id: 'usecore.transcription.stop',
        defaultMessage: 'PARAR'
    },
    transcriptionStart: {
        id: 'usecore.transcription.start',
        defaultMessage: 'INICIAR'
    },
    transcriptionSendingAndTranscribing: {
        id: 'usecore.transcription.sendingAndTranscribing',
        defaultMessage: 'Enviando e Transcrevendo...'
    },
    transcriptionRecordingMessage: {
        id: 'usecore.transcription.recordingMessage',
        defaultMessage: 'Gravando... Clique em Parar para transcrever.'
    },
    transcriptionIdleMessage: {
        id: 'usecore.transcription.idleMessage',
        defaultMessage: 'Clique para gravar ou digite abaixo'
    },
    transcriptionContextInfo: {
        id: 'usecore.transcription.contextInfo',
        defaultMessage: 'Fale normalmente. Nossa agente de IA transcreve, organiza e sugere o preenchimento de formulários e textos livres.'
    },
    transcriptionSelectTemplateClick: {
        id: 'usecore.transcription.selectTemplateClick',
        defaultMessage: 'Clique para escolher um modelo de correção'
    },
    transcriptionTemplateSelected: {
        id: 'usecore.transcription.templateSelected',
        defaultMessage: 'Modelo selecionado'
    },
    transcriptionSection: {
        id: 'usecore.transcription.section',
        defaultMessage: 'Seção:'
    },
    transcriptionFreeMode: {
        id: 'usecore.transcription.freeMode',
        defaultMessage: 'Modo Livre'
    },
    transcriptionForm: {
        id: 'usecore.transcription.form',
        defaultMessage: 'Formulário:'
    },
    transcriptionFormMode: {
        id: 'usecore.transcription.formMode',
        defaultMessage: 'Modo Formulário'
    },
    transcriptionError: {
        id: 'usecore.transcription.error',
        defaultMessage: 'Erro ao processar áudio. Tente novamente.'
    },
    transcriptionMicError: {
        id: 'usecore.transcription.micError',
        defaultMessage: 'Não foi possível acessar o microfone. Verifique permissões.'
    },
    transcriptionInputLabel: {
        id: 'usecore.transcription.inputLabel',
        defaultMessage: 'Descrição do atendimento'
    },
    transcriptionInputPlaceholder: {
        id: 'usecore.transcription.inputPlaceholder',
        defaultMessage: 'Descreva o atendimento do paciente, sintomas, exame físico, diagnóstico...'
    },
    transcriptionProcessingAudio: {
        id: 'usecore.transcription.processingAudio',
        defaultMessage: 'Aguarde, processando áudio...'
    },
    transcriptionRecordingAudio: {
        id: 'usecore.transcription.recordingAudio',
        defaultMessage: 'Gravando áudio...'
    },
    transcriptionTemplateLabel: {
        id: 'usecore.transcription.templateLabel',
        defaultMessage: 'Template de Formatação (Opcional)'
    },
    transcriptionChange: {
        id: 'usecore.transcription.change',
        defaultMessage: 'Alterar'
    },
    transcriptionSelectTemplate: {
        id: 'usecore.transcription.selectTemplate',
        defaultMessage: 'Selecionar um template'
    },
    transcriptionUseTemplateGuide: {
        id: 'usecore.transcription.useTemplateGuide',
        defaultMessage: 'Use um template para guiar a formatação da sua transcrição'
    },
    transcriptionTemplateFormatInfo: {
        id: 'usecore.transcription.templateFormatInfo',
        defaultMessage: 'O texto será formatado seguindo a estrutura deste template.'
    },
    transcriptionRemoveTemplate: {
        id: 'usecore.transcription.removeTemplate',
        defaultMessage: 'Remover template'
    },
    transcriptionReviewInstruction: {
        id: 'usecore.transcription.reviewInstruction',
        defaultMessage: 'Revise e edite o texto antes de processar:'
    },
    transcriptionCorrectingText: {
        id: 'usecore.transcription.correctingText',
        defaultMessage: 'Corrigindo texto...'
    },
    transcriptionAnalyzing: {
        id: 'usecore.transcription.analyzing',
        defaultMessage: 'Analisando transcrição...'
    },
    transcriptionIACorrecting: {
        id: 'usecore.transcription.iaCorrecting',
        defaultMessage: 'A IA está corrigindo e formatando o texto'
    },
    transcriptionIAExtracting: {
        id: 'usecore.transcription.iaExtracting',
        defaultMessage: 'A IA está extraindo informações do texto'
    },
    transcriptionCorrectedText: {
        id: 'usecore.transcription.correctedText',
        defaultMessage: 'Texto corrigido e formatado:'
    },
    transcriptionFreeModeSuccess: {
        id: 'usecore.transcription.freeModeSuccess',
        defaultMessage: 'O texto acima será salvo na seção atual. Clique em "Aplicar" para confirmar.'
    },
    transcriptionSelectFields: {
        id: 'usecore.transcription.selectFields',
        defaultMessage: 'Selecione os campos que deseja preencher:'
    },
    transcriptionSelectAll: {
        id: 'usecore.transcription.selectAll',
        defaultMessage: 'Selecionar todos'
    },
    transcriptionConfidenceHigh: {
        id: 'usecore.transcription.confidenceHigh',
        defaultMessage: 'Alta'
    },
    transcriptionConfidenceMedium: {
        id: 'usecore.transcription.confidenceMedium',
        defaultMessage: 'Média'
    },
    transcriptionConfidenceLow: {
        id: 'usecore.transcription.confidenceLow',
        defaultMessage: 'Baixa'
    },
    transcriptionNoFieldsAuto: {
        id: 'usecore.transcription.noFieldsAuto',
        defaultMessage: 'Nenhum campo foi preenchido automaticamente. Revise a transcrição.'
    },
    transcriptionUnfilledFields: {
        id: 'usecore.transcription.unfilledFields',
        defaultMessage: 'Campos não preenchidos'
    },
    transcriptionFormObservations: {
        id: 'usecore.transcription.formObservations',
        defaultMessage: 'Observações do Formulário'
    },
    transcriptionProcess: {
        id: 'usecore.transcription.process',
        defaultMessage: 'Processar'
    },
    transcriptionCorrect: {
        id: 'usecore.transcription.correct',
        defaultMessage: 'Corrigir'
    },
    transcriptionButtonReview: {
        id: 'usecore.transcription.button.review',
        defaultMessage: 'Revisar'
    },
    transcriptionButtonNext: {
        id: 'usecore.transcription.button.next',
        defaultMessage: 'Próximo'
    },
    transcriptionButtonCorrecting: {
        id: 'usecore.transcription.button.correcting',
        defaultMessage: 'Corrigindo...'
    },
    transcriptionButtonCorrectWithAI: {
        id: 'usecore.transcription.button.correctWithAI',
        defaultMessage: 'Corrigir com IA'
    },
    transcriptionButtonProcessing: {
        id: 'usecore.transcription.button.processing',
        defaultMessage: 'Processando...'
    },
    transcriptionButtonProcessWithAI: {
        id: 'usecore.transcription.button.processWithAI',
        defaultMessage: 'Processar com IA'
    },
    transcriptionButtonApplying: {
        id: 'usecore.transcription.button.applying',
        defaultMessage: 'Aplicando...'
    },
    transcriptionButtonApplyText: {
        id: 'usecore.transcription.button.applyText',
        defaultMessage: 'Aplicar Texto'
    },
    transcriptionButtonApplyFields: {
        id: 'usecore.transcription.button.applyFields',
        defaultMessage: 'Aplicar Campos'
    },
    transcriptionButtonCancel: {
        id: 'usecore.transcription.button.cancel',
        defaultMessage: 'Cancelar'
    },
    transcriptionButtonBack: {
        id: 'usecore.transcription.button.back',
        defaultMessage: 'Voltar'
    },
    transcriptionModalTitle: {
        id: 'usecore.transcription.modalTitle',
        defaultMessage: 'Narrar Atendimento'
    },
    transcriptionRecordingTimer: {
        id: 'usecore.transcription.recordingTimer',
        defaultMessage: '{elapsed} / 03:00'
    },
    transcriptionRecordingLimitReached: {
        id: 'usecore.transcription.recordingLimitReached',
        defaultMessage: 'Limite de 3 minutos atingido. Gravação encerrada automaticamente.'
    },
    transcriptionRateLimitError: {
        id: 'usecore.transcription.rateLimitError',
        defaultMessage: 'Limite de 10 narrações por hora atingido. Tente novamente em alguns minutos.'
    },
    transcriptionMonthlyLimitError: {
        id: 'usecore.transcription.monthlyLimitError',
        defaultMessage: 'Você atingiu o limite mensal de {limit} minutos de narração.'
    },
});
